<template>
  <div
    :id="hasFontColor ? 'application-form-font-color' : ''"
    class="mb-4 field-of-fields p-2"
    :class="{ 'application-form-container': !isEmbed }"
    style="max-width: 100%"
    :style="applicationFormColors"
  >
    <div class="agency-logo-container">
      <img
        :src="customizeLogo || $store.getters.agencyPublic.logo"
        :style="{ maxHeight: agencyLogoHeightInPx }"
      />
    </div>
    <!-- <h1 class="agency-owner center mt-3 mb-4 heavy-font">
      {{ $store.getters.agencyPublic.human_name }}
    </h1> -->
    <div v-if="isBookingOnly && registeredUserId">
      <h2 class="center mt-4 mb-3 heavy-font">
        {{ applicationData.first_name }} {{ applicationData.last_name }}
      </h2>
      <p>Please add bookings, then click Submit button</p>
    </div>
    <h2 class="center mt-4 mb-3 heavy-font" v-if="!hideFormTitle">
      {{ getApplicationProperty("name") }}
    </h2>
    <hr v-if="!hideFormTitle" />
    <div v-show="isShowFormSubmitted" class="center mt-5">
      <!-- <h3>You are already logged in!</h3> -->
      <!-- <h3>You are registered!</h3> -->
      <h3>{{ getLabelByKeys("APPLICATION_FORM.WAIT_FOR_PROCESSING") }}</h3>
      <!-- <div class="header-button mt-4">
        <button @click="dashboardRedirect()" class="button button-1-dark">
          My Dashboard
        </button>
      </div> -->
    </div>
    <div v-show="!isShowFormSubmitted" class="instruction-container">
      <div
        class="instructions-section center mb-2"
        v-html="getApplicationProperty('instructions')"
      ></div>
      <div class="multi-step-progress" v-if="profile.is_multi_steps_form">
        <div class="step-status-text" ref="stepInfo">
          {{
            getLabelByKeys(
              "APPLICATION_FORM.STEP_OF",
              currentStep,
              numberOfStep
            )
          }}
        </div>
        <div class="progress-container">
          <div
            class="current-progress"
            :style="{ width: (currentStep / numberOfStep) * 100 + '%' }"
          ></div>
        </div>
      </div>
      <div class="text-center" v-if="hasParseCVButton">
        <FileWithLabel
          @input="handleUploadFile($event)"
          :isRequired="false"
          :submitInfo="{
              profileBuilder: profileID,
              email: applicationData.email,
            }"
          :uploadLabel="parseCVLabel"
          :hideBorder="true"
        />
      </div>
      <FormGroupRowLayout
        :listFields="listDisplayFields"
        :modelData="applicationData"
        :submitClicked="submitClicked"
        :submitInfo="{
          profileBuilder: profileID,
          email: applicationData.email,
        }"
        :isDragEnabled="true"
        :listAllRelatedFields="profile && profile.is_multi_steps_form? listFields: null"
        @reloadData="reloadApplicationData()"
        @blur="handleBlurField($event)"
      >
        <template
          v-for="dialogSection of listDialogSections"
          :slot="dialogSection.label"
        >
          <BookingSectionWithDialog
            :id="dialogSection.label"
            classList="mt-4"
            v-if="dialogSection.type === FORM_TYPE.BOOKING_SECTION"
            :user="applicationData"
            :key="dialogSection.name"
            :sectionTitle="getFieldProperty(dialogSection, 'label')"
            :description="getFieldProperty(dialogSection, 'description')"
            :adminDescription="
              getFieldProperty(dialogSection, 'adminDescription')
            "
            :name="dialogSection.label"
            v-model="listBookingJobs"
            :categoryList="dialogSection.categoryList"
            :numberOfAllowedChildren="dialogSection.numberOfAllowedChildren"
            :minCount="getMinCount(dialogSection)"
            :excludeChildrenQuestion="dialogSection.excludeChildrenQuestion"
            :excludeAddressQuestion="dialogSection.excludeAddressQuestion"
            :excludeRepeatBooking="dialogSection.excludeRepeatBooking"
            :hasNumberCandidateQuestion="
              dialogSection.hasNumberCandidateQuestion
            "
            :hideAdditionalDateQuestion="
              dialogSection.hideAdditionalDateQuestion
            "
            :submitClicked="submitClicked"
            :listFields="dialogSection.list_fields"
            :bookingField="dialogSection"
            :isInApplicationForm="true"
            :multipleBookingSections="hasMultipleBooking"
            :profileBuilderID="profileID"
            ref="bookingSection"
          />
          <div v-else :key="dialogSection.name">
            <ApplicationSectionWithDialog
              v-if="useModalInApplicationForm"
              :sectionTitle="getFieldProperty(dialogSection, 'label')"
              :name="dialogSection.name"
              :header="getFieldProperty(dialogSection, 'label')"
              :description="getFieldProperty(dialogSection, 'description')"
              :adminDescription="
                getFieldProperty(dialogSection, 'adminDescription')
              "
              :listModelsAdminOnly="dialogSection.listModelsAdminOnly"
              :listModelsAdminClient="dialogSection.listModelsAdminClient"
              :data="mapDependentObjects[dialogSection.label]"
              :minCount="getMinCount(dialogSection)"
              :submitClicked="submitClicked"
              :listFields="dialogSection.list_fields"
              :keyTitles="
                getKeyTitles(
                  dialogSection.list_fields,
                  dialogSection.titleModels
                )
              "
              :field="dialogSection"
              :profileBuilderID="profileID"
              :applicationData="applicationData"
            />
            <ApplicationSectionInput
              v-else
              :sectionTitle="getFieldProperty(dialogSection, 'label')"
              :name="dialogSection.name"
              :header="getFieldProperty(dialogSection, 'label')"
              :description="getFieldProperty(dialogSection, 'description')"
              :adminDescription="
                getFieldProperty(dialogSection, 'adminDescription')
              "
              :listModelsAdminOnly="dialogSection.listModelsAdminOnly"
              :listModelsAdminClient="dialogSection.listModelsAdminClient"
              v-model="mapDependentObjects[dialogSection.label]"
              :minCount="getMinCount(dialogSection)"
              :submitClicked="submitClicked"
              :listFields="dialogSection.list_fields"
              :keyTitles="
                getKeyTitles(
                  dialogSection.list_fields,
                  dialogSection.titleModels
                )
              "
              :field="dialogSection"
              :profileBuilderID="profileID"
              :applicationData="applicationData"
            />
          </div>
        </template>
        <template
          v-for="signField of listSignDocumentField"
          :slot="signField.documentTemplateId + '-' + signField.label"
        >
          <SigningDocument
            :key="signField.label"
            :label="getFieldProperty(signField, 'label')"
            :description="getFieldProperty(signField, 'description')"
            :id="signField.documentTemplateId"
            :template="mapDocumentTemplates[getKeySigningField(signField)]"
            :hideLabel="signField.hideLabel"
            :submitClicked="submitClicked"
            :user="applicationData"
            :mapDependentObjects="mapDependentObjects"
            :mapDependentLabelName="mapDependentLabelName"
            :listOriginal="listOriginalDocuments"
            @signed="handleSignDocument(signField, $event)"
          />
        </template>
        <template
          v-for="evaluationField of listEvaluationField"
          :slot="evaluationField.label"
        >
          <EvaluationInApplicationForm
            :key="evaluationField.label"
            :label="getFieldProperty(evaluationField, 'label')"
            :evaluationField="evaluationField"
            :submitClicked="submitClicked"
            :listOriginal="listOriginalEvaluations"
            @submitted="handleSubmitEvaluation($event)"
          />
        </template>
        <template
          v-for="fileInfoField of listFileInfoFields"
          :slot="fileInfoField.label"
        >
          <div
            class="file-with-info-container"
            :key="'file' + fileInfoField.label"
          >
            <FileWithInfo
              :field="fileInfoField"
              v-model="mapFileInfo[fileInfoField.label]"
              :submitClicked="submitClicked"
              :applicationData="applicationData"
            />
          </div>
        </template>
        <template v-if="paymentField" :slot="paymentField.label">
          <AuthorizeNetPayment
            ref="authorizeNetPayment"
            v-if="hasAuthorizePayment"
            :isRequired="paymentField.isRequired"
            v-model="authorizePaymentInfo"
            :submitClicked="submitClicked"
          />
          <QuickbooksPayment
            ref="quickbooksPayment"
            v-else-if="hasQuickbooksPayment"
            :isRequired="paymentField.isRequired"
            v-model="quickbooksPaymentInfo"
            :submitClicked="submitClicked"
          />
          <StripePayment
            v-else
            ref="stripePayment"
            :user="applicationData"
            :isRequired="paymentField.isRequired"
            :label="getFieldProperty(paymentField, 'label')"
            :description="getFieldProperty(paymentField, 'description')"
            :adminDescription="
              getFieldProperty(paymentField, 'adminDescription')
            "
            :submitClicked="submitClicked"
          />
        </template>
        <template
          v-if="returningApplicantBtnField"
          :slot="returningApplicantBtnField.label"
        >
          <div class="text-center">
            <button
              class="mylisting-button dark-button"
              @click="handleClickReturningApplicantBtn()"
            >
              {{
                returningApplicantBtnField.label ||
                getLabelByKeys("BUTTONS.RETURNING_APPLICANT")
              }}
            </button>
          </div>
        </template>
        <template
          v-if="stripeSubscriptionSelectionField"
          :slot="
            'stripe-subscription-selection' +
            stripeSubscriptionSelectionField.label
          "
        >
          <StripeSubscriptionSelection
            classList=""
            :label="stripeSubscriptionSelectionField.label"
            :description="stripeSubscriptionSelectionField.description"
            :adminDescription="
              stripeSubscriptionSelectionField.adminDescription
            "
            :headerList="stripeSubscriptionSelectionField.headerList"
            :descriptionList="stripeSubscriptionSelectionField.descriptionList"
            :planIdList="stripeSubscriptionSelectionField.planIdList"
            v-model="stripeSubscriptionSelected"
            :submitClicked="submitClicked"
            :isRequired="stripeSubscriptionSelectionField.isRequired"
          />
        </template>
        <template
          v-for="field of listCheckboxConditionFields"
          :slot="'checkbox-condition' + field.label"
        >
          <div :key="'checkbox-condition' + field.label" class="col-lg-12">
            <div
              v-for="(option, index) of convertStringToArray(field.optionList)"
              :key="'condition-option-' + index"
              class="form-check pl-4"
            >
              <input
                class="form-check-input"
                type="checkbox"
                :value="option"
                :id="'checkbox-' + field.label + option + '-' + index"
                v-model="mapCheckboxCondition[field.label + index]"
                @change="onChangeCheckboxCondition()"
              />
              <label
                class="form-check-label ml-1"
                :for="'checkbox-' + field.label + option + '-' + index"
                v-html="option"
              >
              </label>
              <p
                class="required-message checkbox-condition-require"
                v-if="
                  submitClicked && !mapCheckboxCondition[field.label + index]
                "
              >
                {{ getLabelByKeys("ERROR_MESSAGES.FIELD_REQUIRED") }}
              </p>
            </div>
          </div>
        </template>
      </FormGroupRowLayout>
      <hr />
      <GoogleCaptcha
        v-if="isShowSubmitButton && hasCaptcha"
        @verified="isVerifiedCaptcha = true"
      />

      <div class="submit-button-section">
        <button
          v-if="isShowPreviousButton"
          class="previous-button mylisting-button secondary-button"
          @click="handleClickPreviousButton()"
          id="submit-button"
          data-index="0"
        >
          {{ getLabelByKeys("BUTTONS.PREVIOUS") }}
        </button>
        <button
          v-if="isShowNextButton"
          class="next-button mylisting-button dark-button"
          @click="handleClickNextButton()"
          id="submit-button"
          data-index="0"
        >
          {{ getLabelByKeys("BUTTONS.NEXT") }}
        </button>
        <button
          v-if="isShowSubmitButton"
          class="submit-button mylisting-button dark-button"
          @click="submitApplication(), jobViewApplicationSubmitted()"
          id="submit-button"
          data-index="0"
        >
          {{ getLabelByKeys("BUTTONS.SUBMIT") }}
        </button>
      </div>
    </div>

    <a
      href="https://staffing.enginehire.io/"
      target="_blank"
      style="cursor: pointer"
      v-if="
        $store.getters.agencyPublic &&
        !$store.getters.agencyPublic
          .hide_enginehire_branding_from_application_forms
      "
    >
      <div class="center" style="color: #aaa; margin-top: 70px">
        <small style="display: block">Powered by Enginehire</small>
        <img
          class="mt-2"
          style="width: 100px; max-width: 85%"
          src="../../../assets/img/logo/enginehire logo thin dark 1.0 letterpaths.svg"
          alt=""
        />
      </div>
    </a>
    <div
      v-if="hasSpaceBottomEmbedded && isEmbed"
      :style="{ height: `${spaceHeightBottomEmbedded}px` }"
    ></div>
  </div>
</template>

<script>
import axios from "axios";
import {
  BUILDER_USER_TYPE,
  BUILDER_TYPE,
  FORM_TYPE,
} from "../../../constants/custom-define-type";
import { MAP_DIALOG_SECTION } from "../../../constants/field-types";
import {
  STRIPE_PAYMENT_ERROR_IDS,
  PAYMENT_TYPES,
} from "../../../constants/custom-define-type";
import { TIME_FROM_TO_SEPARATOR } from "../../../constants/separator";
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ApplicationSectionWithDialog: () =>
      import("../../common/ApplicationSectionWithDialog"),
    BookingSectionWithDialog: () =>
      import("../../common/bookings/BookingSectionWithDialog"),
    SigningDocument: () => import("../../common/documents/SigningDocument"),
    FileUpload: () => import("../../common/form-elements/FileUpload"),
    StripePayment: () =>
      import("../../common/complex-input-elements/StripePayment.vue"),
    AuthorizeNetPayment: () =>
      import("../../common/complex-input-elements/AuthorizeNetPayment.vue"),
    QuickbooksPayment: () =>
      import("../../common/complex-input-elements/QuickbooksPayment.vue"),
    ApplicationSectionInput: () =>
      import("../../common/ApplicationSectionInput"),
    EvaluationInApplicationForm: () => import("./EvaluationInApplicationForm"),
    FileWithInfo: () =>
      import("../../common/complex-input-elements/FileWithInfo.vue"),
    StripeSubscriptionSelection: () =>
      import(
        "../../common/complex-input-elements/StripeSubcriptionSelection.vue"
      ),
    GoogleCaptcha: () => import("../../common/GoogleCaptcha.vue"),
    FileWithLabel: () => import("../../common/form-elements/FileWithLabel"),
  },
  props: {
    isBookingOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      applicationData: {
        agency: Number(this.$route.params.agencyID),
        application_form: Number(this.$route.params.profileID),
        selected_placement_jobs: [],
      },
      profile: {},
      submitClicked: false,
      mapDependentObjects: {},
      listRejectConditions: [],
      listTypeConditions: [],
      listChecklistConditions: [],
      listBadgeConditions: [],
      listStatusConditions: [],
      listSecondStatusConditions: [],
      listTagConditions: [],
      listKeapTagConditions: [],
      listLocationConditions: [],
      listManagerConditions: [],
      listSecondManagerConditions: [],
      listMembershipConditions: [],
      listErrorConditions: [],
      listModelsAdminOnly: [],
      listModelsAdminClient: [],
      mapDependentLabelName: {},
      listBookingJobs: [],
      mapSignatures: {},
      mapDocumentTemplates: {},
      mapFileInfo: {},
      mapSavedFileInfo: {},
      mapCheckboxCondition: {},
      jobViewID: "", //jobView id to track views & applications. Passed from Job component
      currentStep: 1, // For multi-steps application form
      numberOfStep: 1,
      mapCheckboxConditionStep: {},
      builderLocations: [],
      builderLanguages: [],
      FORM_TYPE: FORM_TYPE,
      PAYMENT_TYPES: PAYMENT_TYPES,
      authorizePaymentInfo: {},
      authorizeOpaqueData: null,
      quickbooksPaymentInfo: {},
      userStatus: null,
      userTypes: null,
      intervalSubmitFunc: null,
      registeredUserId: null,
      listEvaluation: [],
      initialLoggedInUser: null,
      listSnapshots: [],
      listOriginalEvaluations: [],
      listOriginalDocuments: [],
      hasDuplicatedEmailError: false,
      mapSavedDependentObjects: {}, // Use to track if the data is changed since the last submit
      listSavedEvaluations: [],
      listSavedDocuments: [],
      lastTrackingRequest: "",
      preApplicationUserStatus: null,
      isClickPrevious: false,
      stripeSubscriptionSelected: null,
      isVerifiedCaptcha: false,
      mapSectionAPICount: {}, // Ex: /api/references/: 2, /api/experiences/: 1 ...
      stripePaymentMethodId: null
    };
  },
  computed: {
    ...mapGetters([
      "agencyHumanName",
      "useModalInApplicationForm",
      "candidateTypes",
      "candidateTags",
      "employerTypes",
      "employerTags",
      "candidateStatuses",
      "employerStatuses",
      "onlyShowMatchedLocations",
      "publicCandidateList",
      "candidateListMainInfo",
      "isAgent",
      "candidateReapplicationStatuses",
      "clientReapplicationStatuses",
      "userID",
      "agencyLogoHeightInPx",
      "agencyPublic",
      "agencyLocations",
    ]),
    isShowFormSubmitted() {
      if (!this.profile || !this.profile.id) {
        // Not finish loading;
        return false;
      }
      if (this.initialLoggedInUser && this.initialLoggedInUser.status) {
        if (
          this.listAllowApplicantStatuses.includes("All") ||
          this.listAllowApplicantStatuses.includes(
            this.initialLoggedInUser.status
          )
        ) {
          return false;
        }
      }
      return this.userID && !this.isAgent;
    },
    listAllowApplicantStatuses() {
      return this.getListAllowReturningApplicantStatuses(this.profile);
    },
    hasPlaceholderEmailInfo() {
      if (!this.applicationData) {
        return false;
      }
      if (!this.listDisplayFields) {
        return true;
      }
      // If one of these fields are showed => show Submit button
      const listKeys = ["phone", "email", "first_name", "last_name"];
      for (const key of listKeys) {
        if (this.applicationData[key]) {
          return true;
        }
        const listFields = this.listDisplayFields.filter(
          (field) => field.model == key
        );
        for (const field of listFields) {
          if (this.isItemShow(this.applicationData, field, this.listFields)) {
            return true;
          }
        }
      }
      return false;
    },
    redirectToLink() {
      const linkTypes = this.tryGet(
        () => this.profile.additional_information.redirect_to_link_types
      );
      if (linkTypes && linkTypes.length && this.userTypes) {
        const linkItem = linkTypes.find(
          (item) =>
            item.types && this.hasCommonElement(item.types, this.userTypes)
        );
        if (linkItem && linkItem.link) {
          return linkItem.link;
        }
      }
      return this.tryGet(
        () => this.profile.additional_information.redirect_to_link
      );
    },
    redirectImmediately() {
      return this.tryGet(
        () => this.profile.additional_information.redirect_immediately
      );
    },
    applicationFormColors() {
      let colorObject = "";
      if (this.profile.background_color) {
        colorObject += `background-color : ${this.profile.background_color};`;
      }
      if (this.tryGet(() => this.profile.additional_information.font_color)) {
        colorObject += `--appFormFontColor : ${this.profile.additional_information.font_color};`;
      }
      return colorObject;
    },
    hasFontColor() {
      return this.tryGet(() => this.profile.additional_information.font_color);
    },
    hasParseCVButton() {
      return this.tryGet(() => this.profile.additional_information.has_parse_cv_btn);
    },
    parseCVLabel() {
      return this.tryGet(() => this.profile.additional_information.parse_cv_button_label) || "Upload Resume/CV to parse";
    },
    hideAllMenuItems() {
      return this.tryGet(
        () => this.profile.additional_information.hide_all_menu_items
      );
    },
    submissionMessageDuration() {
      return this.tryGet(
        () =>
          this.profile.additional_information.submission_confirmation_duration
      );
    },
    rejectionMessageDuration() {
      return this.tryGet(
        () => this.profile.additional_information.rejection_message_duration
      );
    },
    hasSpaceBottomEmbedded() {
      return this.tryGet(
        () => this.profile.additional_information.has_space_bottom_embedded
      );
    },
    hasCaptcha() {
      return this.tryGet(
        () => this.profile.additional_information.enable_captcha
      );
    },
    spaceHeightBottomEmbedded() {
      return (
        this.tryGet(
          () => this.profile.additional_information.space_height_bottom_embedded
        ) || "500"
      );
    },
    hideFormTitle() {
      if (this.isBookingOnly) {
        return true;
      }
      if (!this.profile || !this.profile.additional_information) {
        return false;
      }
      if (this.profile.additional_information.hide_form_title) {
        return true;
      }
      if (this.isEmbed) {
        if (this.profile.additional_information.hide_form_title_in_embedded) {
          return true;
        }
      }
      return false;
    },
    language() {
      return this.applicationData.language;
    },
    locations() {
      return this.applicationData.locations;
    },
    /* Check if the app is displayed inside an iframe or embed tag
    https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
    */
    isEmbed() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    },
    profileID() {
      return Number(this.$route.params.profileID);
    },
    agencyID() {
      return Number(this.$route.params.agencyID);
    },
    submitSuccessDialog() {
      const messageTypes = this.tryGet(
        () =>
          this.profile.additional_information.submission_confirmation_by_types
      );
      if (messageTypes && messageTypes.length && this.userTypes) {
        const messageItem = messageTypes.find(
          (item) =>
            item.types && this.hasCommonElement(item.types, this.userTypes)
        );
        if (messageItem) {
          return {
            innerHtml: messageItem.message,
          };
        }
      }
      const messageStatus = this.tryGet(
        () =>
          this.profile.additional_information
            .submission_confirmation_by_statuses
      );
      if (messageStatus && messageStatus.length && this.userStatus) {
        const messageItem = messageStatus.find(
          (item) => item.statuses && item.statuses.includes(this.userStatus)
        );
        if (messageItem) {
          return {
            innerHtml: messageItem.message,
          };
        }
      }
      if (this.type === BUILDER_USER_TYPE.UNSPECIFIED) {
        const userType = this.applicationData.userType;
        if (userType === this.candidateOption) {
          const message =
            this.getAdditionalInfo("submission_confirmation_candidate") ||
            this.getLabelByKeys(
              "RESULT_DIALOGS.SUBMIT_SUCCESS_CONTACT_FORM.INNER_HTML"
            );
          if (message) {
            return {
              innerHtml: message,
            };
          }
        } else if (userType === this.clientOption) {
          const message =
            this.getAdditionalInfo("submission_confirmation_client") ||
            this.getLabelByKeys(
              "RESULT_DIALOGS.SUBMIT_SUCCESS_CONTACT_FORM.INNER_HTML"
            );
          if (message) {
            return {
              innerHtml: message,
            };
          }
        }
      }
      const submissionConfirmationMessage = this.getApplicationProperty(
        "submission_confirmation"
      );
      if (this.type === BUILDER_USER_TYPE.CLIENT) {
        return this.getSubmissionDialogContent(
          submissionConfirmationMessage,
          this.$store.getters.submitSuccessFamilyForm
        );
      } else {
        return this.getSubmissionDialogContent(
          submissionConfirmationMessage,
          this.$store.getters.submitSuccessNannyForm
        );
      }
    },
    submitRejectDialog() {
      const rejectionMessage = this.getApplicationProperty("rejection_message");
      return this.getSubmissionDialogContent(
        rejectionMessage,
        this.$store.getters.submitRejectForm
      );
    },
    hasLocationQuestion() {
      if (
        this.profile.additional_information &&
        this.profile.additional_information.exclude_location_question
      ) {
        return false;
      }
      if (this.listLocations && this.listLocations.length > 1) {
        return true;
      }
      return false;
    },
    hasLanguageQuestion() {
      if (
        this.profile.additional_information &&
        this.profile.additional_information.exclude_language_question
      ) {
        return false;
      }
      if (this.listLanguages && this.listLanguages.length > 1) {
        return true;
      }
      return false;
    },
    listFields() {
      let listFields = this.profile.list_fields;
      if (!listFields) {
        return [];
      }
      // Not on application but in profile
      listFields = listFields.filter((field) => !field.notInApplication);
      // Merge two array, then flat the result
      const mergeExcludeModel = [].concat.apply(
        [],
        [...this.listModelsAdminOnly, ...this.listModelsAdminClient]
      );
      listFields = listFields.filter(
        (field) => !mergeExcludeModel.includes(field.model)
      );
      // Filter hidden fields
      listFields = listFields.filter((field) => !field.isHidden);
      // Check to insert location fields
      if (this.hasLocationQuestion) {
        // Find index of location field in list fields (it is below the HTML field or precondition check fields)
        let locationFieldIndex = 0;
        let stepIndex = 1;
        for (const field of listFields) {
          if (field.isPreconditionCheck) {
            locationFieldIndex += 1;
            stepIndex = 2;
          } else if (field.type === FORM_TYPE.HTML || field.isHidden) {
            locationFieldIndex += 1;
          } else {
            break;
          }
        }
        // Insert locations field
        let locationQuestion = "Which locations are you interested in?";
        if (
          this.profile.additional_information &&
          this.profile.additional_information.location_question
        ) {
          locationQuestion =
            this.profile.additional_information.location_question;
        }

        const locationField = {
          label: locationQuestion,
          type: FORM_TYPE.CHECKBOX,
          optionList: this.listLocations.join("\n"),
          model: "locations",
          stepIndex: stepIndex,
        };
        // Multilanguage for location
        if (
          this.listLanguages &&
          this.listLanguages.some((lang) => lang !== "English")
        ) {
          // Multilanguage for label
          if (this.profile.additional_information) {
            for (const lang of this.listLanguages) {
              locationField["label_lang_" + lang] =
                this.profile.additional_information[
                  "location_question_lang_" + lang
                ];
            }
          }
        }
        if (
          this.profile.additional_information &&
          this.profile.additional_information.single_location
        ) {
          listFields.splice(locationFieldIndex, 0, {
            ...locationField,
            type: FORM_TYPE.RADIO,
            isShareModel: true,
            shareModelIndex: 0,
          });
        } else {
          listFields.splice(locationFieldIndex, 0, locationField);
        }
      }

      // Check to insert languages field
      if (this.hasLanguageQuestion) {
        // Find index of language field in list fields (it is below the HTML field or precondition check fields)
        let languageFieldIndex = 0;
        let stepIndex = 1;
        for (const field of listFields) {
          if (field.isPreconditionCheck) {
            languageFieldIndex += 1;
            stepIndex = 2;
          } else if (field.type === FORM_TYPE.HTML || field.isHidden) {
            languageFieldIndex += 1;
          } else {
            break;
          }
        }
        // Insert locations field
        let languageQuestion = "Which language do you want to use?";
        if (
          this.profile.additional_information &&
          this.profile.additional_information.language_question
        ) {
          languageQuestion =
            this.profile.additional_information.language_question;
        }
        const languageField = {
          label: languageQuestion,
          type: FORM_TYPE.RADIO,
          optionList: this.listLanguages.join("\n"),
          model: "language",
          stepIndex: stepIndex,
        };
        // Multilanguage for label
        if (this.profile.additional_information) {
          for (const lang of this.listLanguages) {
            languageField["label_lang_" + lang] =
              this.profile.additional_information[
                "language_question_lang_" + lang
              ];
          }
        }
        listFields.splice(languageFieldIndex, 0, languageField);
      }

      // Check to insert user type question
      if (this.type === BUILDER_USER_TYPE.UNSPECIFIED) {
        // Find index of user type field in list fields (it is below the HTML field or precondition check fields)
        let userTypeFieldIndex = 0;
        let stepIndex = 1;
        for (const field of listFields) {
          if (field.isPreconditionCheck) {
            userTypeFieldIndex += 1;
            stepIndex = 2;
          } else if (field.type === FORM_TYPE.HTML || field.isHidden) {
            userTypeFieldIndex += 1;
          } else {
            break;
          }
        }
        const userTypeField = {
          label: this.getAdditionalInfo(
            "user_type_question",
            "Please specify user type?"
          ),
          type: FORM_TYPE.RADIO,
          optionList: [this.candidateOption, this.clientOption],
          stepIndex: stepIndex,
          model: "userType",
        };
        // Multilanguage for label
        if (this.profile.additional_information) {
          for (const lang of this.listLanguages) {
            userTypeField["label_lang_" + lang] =
              this.profile.additional_information[
                "user_type_question_lang_" + lang
              ] || userTypeField.label;
            const candidateOption =
              this.profile.additional_information[
                "user_type_candidate_option_lang_" + lang
              ];
            const clientOption =
              this.profile.additional_information[
                "user_type_client_option_lang_" + lang
              ];
            if (candidateOption && clientOption) {
              userTypeField["optionList_lang_" + lang] = [
                candidateOption,
                clientOption,
              ];
            }
          }
        }
        listFields.splice(userTypeFieldIndex, 0, userTypeField);
      }

      // Check duplicate model and print to console
      /*
      if (listFields) {
        const listModels = listFields
          .filter((field) => field.model)
          .map((field) => field.model);
        this.findDuplicates(listModels);
      }
      console.log(listFields.filter(field => field.model === 'multiselect20'));
      */
      if (this.isBookingOnly) {
        if (this.registeredUserId) {
          listFields = listFields.filter(
            (field) => field.type === FORM_TYPE.BOOKING_SECTION
          );
        } else {
          listFields = [];
        }
      }
      return listFields;
    },
    listFileModels() {
      if (!this.listFields) {
        return [];
      }
      return this.listFields
        .filter((field) => field.type === FORM_TYPE.FILE)
        .map((field) => field.model);
    },
    candidateOption() {
      return this.getAdditionalInfo("user_type_candidate_option", "Candidate");
    },
    clientOption() {
      return this.getAdditionalInfo("user_type_client_option", "Client");
    },
    listDisplayFields() {
      // check for fields that are not required in application but required in profile
      this.listFields.map((field) => {
        if (field.notRequiredInApplication) {
          field.isRequired = false;
        }
      });
      if (this.profile.is_multi_steps_form) {
        return this.listFields.filter(
          (field) => field.stepIndex === this.currentStep
        );
      } else {
        return this.listFields;
      }
    },
    listDialogSections() {
      return this.listFields.filter(
        (field) =>
          [
            FORM_TYPE.SLOT,
            FORM_TYPE.SECTION,
            FORM_TYPE.BOOKING_SECTION,
          ].includes(field.type) &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    listFileInfoFields() {
      return this.listFields.filter(
        (field) =>
          field.type === FORM_TYPE.FILE_WITH_INFO &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    stripeSubscriptionSelectionField() {
      if (!this.listFields) {
        return null;
      }
      return this.listFields.find(
        (field) =>
          field.type === FORM_TYPE.STRIPE_SUBSCRIPTION_SELECTION &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    hasMultipleBooking() {
      let count = 0;
      for (const section of this.listDialogSections) {
        if (section.type == FORM_TYPE.BOOKING_SECTION) {
          count += 1;
        }
      }
      return count > 1;
    },
    paymentField() {
      return this.listFields.find(
        (field) =>
          field.type === FORM_TYPE.PAYMENT &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    creditPackageSelectionField() {
      return this.listFields.find(
        (field) =>
          [
            FORM_TYPE.CREDIT_PACKAGE_SELECTION,
            FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION,
          ].includes(field.type) &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    isMonthlyCreditPackageSelection() {
      if (!this.creditPackageSelectionField) {
        return false;
      }
      return (
        this.creditPackageSelectionField.type ===
        FORM_TYPE.MONTHLY_CREDIT_PACKAGE_SELECTION
      );
    },
    listCheckboxConditionFields() {
      return this.listFields.filter(
        (field) => field.type === FORM_TYPE.CHECKBOX_CONDITION
      );
    },
    listAllSignDocumentField() {
      return this.listFields.filter(
        (field) => field.type === FORM_TYPE.SIGN_DOCUMENT
      );
    },
    listSignDocumentField() {
      return this.listAllSignDocumentField.filter((field) =>
        this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    listAllEvaluationField() {
      return this.listFields.filter(
        (field) => field.type === FORM_TYPE.EVALUATION
      );
    },
    listEvaluationField() {
      return this.listAllEvaluationField.filter((field) =>
        this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    returningApplicantBtnField() {
      return this.listFields.find(
        (field) =>
          field.type === FORM_TYPE.RETURNING_APPLICANT_BTN &&
          this.isItemShow(this.applicationData, field, this.listFields)
      );
    },
    type() {
      return this.profile.user_type;
    },
    isShowSubmitButton() {
      if (this.isBookingOnly) {
        if (!this.registeredUserId) {
          return false;
        }
        return true;
      }
      if (!this.hasPlaceholderEmailInfo) {
        return false;
      }
      if (!this.profile.is_multi_steps_form) {
        return true;
      }
      return this.currentStep === this.numberOfStep;
    },
    isShowPreviousButton() {
      if (!this.profile.is_multi_steps_form) {
        return false;
      }
      return this.currentStep !== 1;
    },
    isShowNextButton() {
      if (!this.profile.is_multi_steps_form) {
        return false;
      }
      return this.currentStep !== this.numberOfStep;
    },
    listLocations() {
      if (this.builderLocations && this.builderLocations.length > 0) {
        return this.builderLocations;
      }
      return this.agencyLocations || [];
    },
    listLanguages() {
      if (this.builderLanguages && this.builderLanguages.length > 0) {
        return this.builderLanguages;
      }
      if (this.$store.getters.agencyPublic) {
        const languages = this.$store.getters.agencyPublic.listLanguages;
        if (languages && languages.length > 0) {
          return languages;
        }
      }
      return [];
    },
    hasAuthorizePayment() {
      return (
        this.paymentField &&
        this.paymentField.paymentType === PAYMENT_TYPES.AUTHORIZE
      );
    },
    hasQuickbooksPayment() {
      return (
        this.paymentField &&
        this.paymentField.paymentType === PAYMENT_TYPES.QUICKBOOKS
      );
    },
    hasStripePayment() {
      return (
        this.paymentField &&
        ![PAYMENT_TYPES.AUTHORIZE, PAYMENT_TYPES.QUICKBOOKS].includes(
          this.paymentField.paymentType
        )
      );
    },
    apiLoginID() {
      if (
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.authorize_net_params
      ) {
        return this.$store.getters.agencyPublic.authorize_net_params.loginID;
      }
      return "";
    },
    clientKey() {
      if (
        this.$store.getters.agencyPublic &&
        this.$store.getters.agencyPublic.authorize_net_params
      ) {
        return this.$store.getters.agencyPublic.authorize_net_params.clientKey;
      }
      return "";
    },
    listRequiredModelAuthorizePayment() {
      const ref = this.$refs.authorizeNetPayment;
      if (!ref) {
        return [];
      }
      const listFields = ref.listFields;
      if (!listFields) {
        return [];
      }
      return listFields
        .filter((field) => field.isRequired)
        .map((field) => field.model);
    },
    listRequiredModelQuickbooksPayment() {
      const ref = this.$refs.quickbooksPayment;
      if (!ref) {
        return [];
      }
      const listFields = ref.listFields;
      if (!listFields) {
        return [];
      }
      return listFields
        .filter((field) => field.isRequired)
        .map((field) => field.model);
    },
    isOneItemPerRow() {
      return (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.one_field_per_row_email
      );
    },
    chargeClientWhenBooking() {
      return (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.charge_client_when_booking
      );
    },
    includeCandidatePayment() {
      return (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.include_candidate_payment
      );
    },
    employerTypesNotCharge() {
      return (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.employer_types_not_charge
      );
    },
    chargeOn() {
      if (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.charge_on
      ) {
        return this.profile.additional_information.charge_on;
      }
      return "submit_form";
    },
    isTrackApplication() {
      return (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.is_track_application
      );
    },
    applicationAbandonStatus() {
      if (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.application_abandon_status
      ) {
        return this.profile.additional_information.application_abandon_status;
      }
      return "Application Started";
    },
    secondStatusChangeTo() {
      if (
        this.profile &&
        this.profile.additional_information &&
        this.profile.additional_information.second_status_change
      ) {
        return this.profile.additional_information.second_status_change;
      }
      return null;
    },
    customizeLogo() {
      return this.tryGet(() =>
        this.convertToAbsolutePath(
          this.profile.additional_information.customize_logo
        )
      );
    },
    hideDuplicatedEmailWarning() {
      return this.tryGet(
        () => this.profile.additional_information.hide_duplicate_email_warning
      );
    },
    hideDuplicatedPhoneWarning() {
      return this.tryGet(
        () => this.profile.additional_information.hide_duplicate_phone_warning
      );
    },
  },
  watch: {
    agencyPublic: {
      handler(val) {
        if (!val) {
          return;
        }
        this.setPredefinedOptionList();
      },
      immediate: true,
    },
    language: {
      handler(val) {
        this.$store.dispatch("setLanguage", val);
      },
      immediate: true,
    },
    hideAllMenuItems: {
      handler(val) {
        if (!this.isAgent) {
          this.setHideMenuBar(val);
        }
      },
      immediate: true,
    },
    locations: {
      handler(val) {
        // Check if filler is no longer matched because of changing locations
        if (!this.onlyShowMatchedLocations) {
          return;
        }
        if (!this.listBookingJobs) {
          return;
        }
        const listAssignedBookings = this.listBookingJobs.filter(
          (booking) => booking.filler
        );
        if (!listAssignedBookings.length) {
          return;
        }
        let listCandidates =
          this.candidateListMainInfo || this.publicCandidateList;
        if (
          this.applicationData.locations &&
          this.applicationData.locations.length
        ) {
          // Check if locations of filler is not matched with locations of poster => clear filler
          listCandidates = listCandidates.filter((candidate) =>
            this.hasCommonElement(
              candidate.locations,
              this.applicationData.locations
            )
          );
          const listCandidateIds = listCandidates.map(
            (candidate) => candidate.id
          );
          for (const booking of listAssignedBookings) {
            if (!listCandidateIds.includes(booking.filler)) {
              delete booking.filler;
              delete booking.filled;
              delete booking.filler_name;
              delete booking.filled_date;
            }
          }
        }
      },
      immediate: true,
    },
  },
  async created() {
    if (this.$route.query) {
      if (!isNaN(this.$route.query.step)) {
        // Reload saved data to set initial value for all data
        // In case user click Next, Previous, router changes, page is reload, we need to restore data
        this.currentStep = Number(this.$route.query.step);
        const savedData = this.$store.getters.applicationStateData;
        if (savedData && Object.keys(savedData).length) {
          for (const [key, value] of Object.entries(savedData)) {
            this[key] = value;
          }
          this.$nextTick(() => {
            if (this.currentStep > 1 && this.currentStep < this.numberOfStep) {
              const listVisibleFields = this.listDisplayFields.filter((field) =>
                this.isItemShow(this.applicationData, field, this.listFields)
              );
              if (!listVisibleFields.length) {
                // There is no field in current step => jump to next steps or previous steps
                if (this.isClickPrevious) {
                  this.currentStep = this.currentStep - 1;
                } else {
                  this.currentStep = this.currentStep + 1;
                }
                this.$store.dispatch("setApplicationStateData", this.$data);
                this.$router.replace({
                  name: "Application Form Builder",
                  query: {
                    step: this.currentStep,
                  },
                });
                return;
              }
            }
            setTimeout(() => {
              if (this.$refs.stepInfo) {
                if (this.isEmbed) {
                  try {
                    // ScrollIntoView does not work on iframe in Safari
                    window.parent.postMessage(
                      this.$refs.stepInfo.getBoundingClientRect().top,
                      "*"
                    );
                  } catch (e) {}
                } else {
                  this.$refs.stepInfo.scrollIntoView({
                    block: "start",
                    behavior: "smooth",
                  });
                }
              }
              if (this.isTrackApplication) {
                // Get number of messages
                this.intervalSubmitFunc = setInterval(async () => {
                  this.submitTrackingApplicationData();
                }, 60000);
              }
            }, 50);
          });

          return;
        } else {
          // Redirect to first page
          if (this.currentStep && this.currentStep !== 1) {
            this.$router.replace({
              name: "Application Form Builder",
            });
          }
        }
      }
      // Init application data via URL
      for (const key of Object.keys(this.$route.query)) {
        if (["step", "user", "hashId"].includes(key)) {
          continue;
        }
        let value = this.$route.query[key];
        if (key === "referral_code") {
          this.applicationData.referal_id = value;
          continue;
        }
        // In case of array in URL
        try {
          value = JSON.parse(decodeURIComponent(value));
        } catch (e) {}
        if (!this.applicationData[key]) {
          this.applicationData[key] = value;
          if (key.indexOf("multiselect") === 0 || ["types"].includes(key)) {
            if (!Array.isArray(value)) {
              this.applicationData[key] = [value];
            }
          }
        }
      }
      this.applicationData = { ...this.applicationData };
    }
    console.log(this.$data);
    this.$store.dispatch("setAgencyID", this.agencyID);
    await this.loadProfileBuilderFields();
    if (this.userID && !this.isAgent) {
      // Load current user status
      this.initialLoggedInUser = await this.loadPreApplication(this.userID);
    }

    // Load pre application
    if (this.$route.query) {
      if (this.$route.query.user || this.$route.query.hashId) {
        this.loadPreApplication(
          this.$route.query.user,
          this.$route.query.hashId
        );
      }
    }

    if (this.isBookingOnly) {
      this.handleClickReturningApplicantBtn();
    }

    // Sets the jobViewID of the current job view object
    this.jobViewID = this.$route.query.jobViewID;
    console.log(`Job View ID: ${this.jobViewID}`);
    if (this.isTrackApplication) {
      // Get number of messages
      this.intervalSubmitFunc = setInterval(async () => {
        this.submitTrackingApplicationData();
      }, 60000);
    }
  },
  beforeDestroy() {
    if (this.intervalSubmitFunc) {
      clearInterval(this.intervalSubmitFunc);
    }
    this.setHideMenuBar(false);
  },
  methods: {
    ...mapActions([
      "setHideMenuBar",
      "setCandidateBuilderList",
      "setClientBuilderList",
      "reloadProfileBuilderList",
    ]),
    getDuplicatedEmailWarning(email) {
      return this.getSubmissionDialogContent(
        this.tryGet(() =>
          this.profile.additional_information.duplicated_email_warning
            .replace(
              "[[returning-application-button]]",
              `<a class="button-link" id="returning-application-button">here</a>`
            )
            .replace("[[email]]", email)
        ),
        { key: "APPLICATION_FORM_DUPLICATED_EMAIL", params: [email] }
      );
    },
    getDuplicatedPhoneWarning(phone) {
      return this.getSubmissionDialogContent(
        this.tryGet(() =>
          this.profile.additional_information.duplicated_phone_warning
            .replace(
              "[[returning-application-button]]",
              `<a class="button-link" id="returning-application-button">here</a>`
            )
            .replace("[[phone]]", phone)
        ),
        { key: "APPLICATION_FORM_DUPLICATED_PHONE", params: [phone] }
      );
    },
    setPredefinedOptionList() {
      if (!this.profile || !this.profile.list_fields) {
        return;
      }
      this.profile.list_fields.forEach((field) => {
        if (!field.optionList || !field.optionList.length) {
          if (field.model === "types") {
            field.optionList =
              this.type === BUILDER_USER_TYPE.CANDIDATE
                ? this.candidateTypes
                : this.employerTypes;
          }
          if (field.model === "tags") {
            field.optionList =
              this.type === BUILDER_USER_TYPE.CANDIDATE
                ? this.candidateTags
                : this.employerTags;
          }
          if (field.model === "status") {
            field.optionList =
              this.type === BUILDER_USER_TYPE.CANDIDATE
                ? this.candidateStatuses
                : this.employerStatuses;
          }
          if (field.model === "locations") {
            field.optionList = this.agencyLocations;
          }
        }
      });
    },
    isValidPreApplicationUser(user) {
      // Validate agency id
      if (this.agencyID !== user.agency_id) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }

      // Validate user type (client/candidate)
      const is_candidate = this.type === BUILDER_USER_TYPE.CANDIDATE;
      const is_employer = this.type === BUILDER_USER_TYPE.CLIENT;
      if (is_candidate && !user.is_candidate) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }
      if (is_employer && !user.is_employer) {
        this.showErrorDialog("APPLICATION_FORM_USER_INCORRECT_USER_ID");
        return false;
      }
      if (this.isBookingOnly) {
        return true;
      }

      // Validate user status
      const allowStatuses = this.getListAllowReturningApplicantStatuses(
        this.profile
      );
      if (!allowStatuses.includes("All")) {
        if (!allowStatuses.includes(user.status)) {
          this.showErrorDialog("APPLICATION_FORM_USER_SUBMITTED");
          return false;
        }
      }
      return true;
    },
    async loadProfileBuilderFields() {
      // Get list builder
      const listBuilder = await this.getListProfileBuilder();
      if (listBuilder == null) {
        return;
      }
      // Find the builder by profileID
      this.profile = listBuilder.find(
        (builder) => builder.id === this.profileID
      );
      if (this.profile == null) {
        return;
      }

      // Merge list field of section builder into application builder
      const builder = this.mergeBuilders(this.profile, listBuilder);
      this.builderLocations = builder.locations;
      this.builderLanguages = builder.languages;
      if (this.profile.is_multi_steps_form) {
        const listStepIndices = builder.listFields.map(
          (field) => field.stepIndex
        );
        console.log(listStepIndices);
        this.numberOfStep = Math.max(...listStepIndices);
      }
      this.profile.list_fields = builder.listFields;
      this.listRejectConditions = builder.listRejectConditions;
      this.listTypeConditions = builder.listTypeConditions;
      this.listTagConditions = builder.listTagConditions;
      this.listChecklistConditions = builder.listChecklistConditions;
      this.listBadgeConditions = builder.listBadgeConditions;
      this.listStatusConditions = builder.listStatusConditions;
      this.listSecondStatusConditions = builder.listSecondStatusConditions;
      this.listKeapTagConditions = builder.listKeapTagConditions;
      this.listLocationConditions = builder.listLocationConditions;
      this.listManagerConditions = builder.listManagerConditions;
      this.listSecondManagerConditions = builder.listSecondManagerConditions;
      this.listMembershipConditions = builder.listMembershipConditions;
      this.listErrorConditions = builder.listErrorConditions;
      this.listModelsAdminOnly = builder.listModelsAdminOnly;
      this.listModelsAdminClient = builder.listModelsAdminClient;

      this.profile.list_fields.forEach((field) => {
        if (field.optionList && typeof field.optionList === "string") {
          const options = field.optionList
            .split("\n")
            .map((option) => option.trim())
            .filter((option) => option.length > 0);
          field.optionList = options;
        }
        // Add email validation
        if (field.model && ["email", "email2"].includes(field.model)) {
          field.validation = [
            {
              regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/,
              message: "Please enter a valid email.",
            },
          ];
        }
      });

      this.setPredefinedOptionList();

      // Init mapDependentObjects
      const listDialogFields = this.profile.list_fields.filter(
        (field) =>
          [
            FORM_TYPE.SLOT,
            FORM_TYPE.SECTION,
            FORM_TYPE.BOOKING_SECTION,
          ].includes(field.type) &&
          field.name !== MAP_DIALOG_SECTION.People.name
      );
      listDialogFields.forEach((field) => {
        if (!this.mapDependentObjects[field.label]) {
          this.mapDependentObjects[field.label] = [];
        }
        this.mapDependentLabelName[field.label] = field.name;
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[field.name].apiKey
        );
        if (apiKey) {
          let count = this.mapSectionAPICount[apiKey] || 0;
          this.mapSectionAPICount[apiKey] = count + 1;
        }
      });
      this.saveMapDependentObjects();

      // Init map file info
      const listFileInfoFields = this.profile.list_fields.filter(
        (field) => field.type === FORM_TYPE.FILE_WITH_INFO
      );

      listFileInfoFields.forEach((field) => {
        this.mapFileInfo[field.label] = [];
      });
      this.mapFileInfo = Object.assign({}, this.mapFileInfo);
      this.saveMapFileInfo();

      // Init map checkbox condition with all value is false
      const listCheckboxConditionFields = this.profile.list_fields.filter(
        (field) => field.type === FORM_TYPE.CHECKBOX_CONDITION
      );
      listCheckboxConditionFields.forEach((field) => {
        const optionList = this.convertStringToArray(field.optionList);
        for (let index = 0; index < optionList.length; index++) {
          this.mapCheckboxCondition[field.label + index] = false;
          if (this.profile.is_multi_steps_form) {
            this.mapCheckboxConditionStep[field.label + index] =
              field.stepIndex;
          }
        }
      });
      // Init value for share model and list text fields
      const listShareModelFields = this.profile.list_fields.filter(
        (field) => field.isShareModel || field.type === FORM_TYPE.LIST_TEXTBOX
      );
      listShareModelFields.forEach((field) => {
        if (this.applicationData[field.model] == null) {
          this.applicationData[field.model] = [];
        }
        this.applicationData[field.model][field.shareModelIndex] = "";
      });
      // Initial locations value
      if (this.applicationData.locations == null) {
        this.applicationData.locations = [];
      }

      // Get documenttemplates
      for (const field of this.listAllSignDocumentField) {
        if (field.documentTemplateId) {
          const res = await axios.get(
            `/api/documenttemplates/?id=${field.documentTemplateId}`
          );
          if (res && res.data && res.data.length > 0) {
            this.mapDocumentTemplates[this.getKeySigningField(field)] =
              res.data[0];
          }
        }
      }
      this.mapDocumentTemplates = Object.assign({}, this.mapDocumentTemplates);
      // If there is only 1 language in the list, set it as selected language
      if (this.listLanguages && this.listLanguages.length === 1) {
        this.applicationData.language = this.listLanguages[0];
      }
    },
    saveMapDependentObjects() {
      this.mapSavedDependentObjects = {};
      try {
        this.mapSavedDependentObjects = JSON.parse(
          JSON.stringify(this.mapDependentObjects)
        );
      } catch (_) {}
    },
    saveMapFileInfo() {
      this.mapSavedFileInfo = {};
      try {
        this.mapSavedFileInfo = JSON.parse(JSON.stringify(this.mapFileInfo));
      } catch (_) {}
    },
    saveListEvaluations() {
      this.listSavedEvaluations = [];
      try {
        this.listSavedEvaluations = JSON.parse(
          JSON.stringify(this.listEvaluation)
        );
      } catch (_) {}
    },
    saveListDocuments(listDocs) {
      this.listSavedDocuments = [];
      try {
        this.listSavedDocuments = JSON.parse(JSON.stringify(listDocs));
      } catch (_) {}
    },
    getKeySigningField(field) {
      return field.label + field.documentTemplateId;
    },
    getAdditionalInfo(key, defaultValue) {
      if (
        this.profile.additional_information &&
        this.profile.additional_information[key]
      ) {
        return this.profile.additional_information[key];
      }
      return defaultValue;
    },
    getApplicationProperty(propertyName) {
      if (this.$store.getters.language && this.profile.additional_information) {
        const value =
          this.profile.additional_information[
            propertyName + "_lang_" + this.$store.getters.language
          ];
        if (value) {
          return value;
        }
      }
      return this.profile[propertyName];
    },
    getFieldProperty(item, key) {
      const language = this.$store.getters.language;
      if (!language) {
        return item[key];
      }
      if (item[key + "_lang_" + language]) {
        return item[key + "_lang_" + language];
      }
      return item[key];
    },
    onChangeCheckboxCondition() {
      this.$nextTick(() => {
        this.mapCheckboxCondition = JSON.parse(
          JSON.stringify(this.mapCheckboxCondition)
        );
      });
    },
    handleSignDocument(signField, data) {
      this.mapSignatures[signField.label] = data;
    },
    async getListProfileBuilder() {
      return new Promise(async (resolve, reject) => {
        const res = await axios.get(
          `/get-application-profile-sections/?application_id=${this.profileID}`
        );
        if (res) {
          if (this.type === BUILDER_USER_TYPE.CANDIDATE) {
            this.setCandidateBuilderList(res.data);
          } else {
            this.setClientBuilderList(res.data);
          }
          resolve(res.data);
        } else {
          reject();
        }
      });
    },
    checkInvalidFields() {
      const errorInfo = this.hasInvalidField(
        this.applicationData,
        this.listFields
      );
      if (errorInfo) {
        console.log("Invalid field");
        return errorInfo;
      }
      // Check if credit package selection field is required
      if (
        this.creditPackageSelectionField &&
        this.creditPackageSelectionField.isRequired
      ) {
        if (!this.applicationData.credit_package) {
          console.log("Credit package require");
          return {
            field: this.creditPackageSelectionField,
            type: "Required Field",
          };
        }
      }
      if (
        this.stripeSubscriptionSelectionField &&
        this.stripeSubscriptionSelectionField.isRequired
      ) {
        if (
          !this.stripeSubscriptionSelected ||
          !this.stripeSubscriptionSelected.planId
        ) {
          return {
            field: this.stripeSubscriptionSelectionField,
            type: "Required Field",
          };
        }
      }
      // Check checkbox condition is uncheck
      if (Object.values(this.mapCheckboxCondition).includes(false)) {
        // Check if the field is showed
        for (const checkboxConditionField of this.listCheckboxConditionFields) {
          // Field is not showed
          if (
            !this.isItemShow(
              this.applicationData,
              checkboxConditionField,
              this.listFields
            )
          ) {
            continue;
          }
          const optionList = this.convertStringToArray(
            checkboxConditionField.optionList
          );
          // Check if there is any unchecked option
          for (let index = 0; index < optionList.length; index++) {
            if (
              this.mapCheckboxCondition[
                checkboxConditionField.label + index
              ] === false
            ) {
              console.log(
                "Checkbox condition unchecked",
                checkboxConditionField.label + index
              );
              return {
                field: checkboxConditionField,
                type: "Required Field",
              };
              return true;
            }
          }
        }
      }
      return this.checkInvalidPaymentField();
    },
    checkInvalidPaymentField() {
      // Check payment input
      if (this.paymentField) {
        // Check if payment information is invalid
        if (this.hasAuthorizePayment) {
          if (this.paymentField.isRequired) {
            if (!this.authorizePaymentInfo) {
              console.log("Invalid authorize.net payment info");
              return {
                message: "Authorize.net payment information required",
              };
            }
            for (const model of this.listRequiredModelAuthorizePayment) {
              if (!this.authorizePaymentInfo[model]) {
                console.log(
                  `Required ${model} in authorize.net payment information`
                );
                return {
                  message: `Required ${this.convertUnderscoreToLabel(
                    model
                  )} in authorize.net payment information`,
                };
              }
            }
          }
        } else if (this.hasQuickbooksPayment) {
          if (this.paymentField.isRequired) {
            if (!this.quickbooksPaymentInfo) {
              console.log("Quickbooks payment info");
              return {
                message: "Required quickbooks payment information",
              };
            }
            for (const model of this.listRequiredModelQuickbooksPayment) {
              if (!this.quickbooksPaymentInfo[model]) {
                console.log("Invalid Quickbooks payment info", model);
                return {
                  message: `Required ${this.convertUnderscoreToLabel(
                    model
                  )} in Quickbooks payment information`,
                };
              }
            }
          }
        } else {
          // Default is Stripe
          const invalidPaymentEl = document.getElementById(
            STRIPE_PAYMENT_ERROR_IDS.INVALID
          );
          if (invalidPaymentEl) {
            console.log("Invalid stripe payment info");
            return {
              message: "Invalid stripe payment information",
            };
            return true;
          }
          // Check if payment information is empty
          if (this.paymentField.isRequired) {
            const emptyPaymentEl = document.getElementById(
              STRIPE_PAYMENT_ERROR_IDS.EMPTY
            );
            if (emptyPaymentEl) {
              return {
                message: "Stripe payment information require",
              };
              console.log("Empty stripe payment info");
              return true;
            }
          }
        }
      }
      return false;
    },
    checkMissingDependencyObject() {
      // Get dialogsection corresponding with current step
      let listDialogSections = this.listDialogSections;
      if (this.profile.is_multi_steps_form) {
        listDialogSections = listDialogSections.filter(
          (dialogSection) => dialogSection.stepIndex === this.currentStep
        );
      }

      // Check to find any missing dependency object
      for (const dialogSection of listDialogSections) {
        if (dialogSection.name === "Booking") {
          continue;
        }
        if (this.getMinCount(dialogSection)) {
          if (this.mapDependentObjects[dialogSection.label] == null) {
            this.showMissingDependencyError(dialogSection);
            return true;
          }
          if (
            this.mapDependentObjects[dialogSection.label].length <
            dialogSection.minCount
          ) {
            this.showMissingDependencyError(dialogSection);
            return true;
          }
        }
        // Validate required field if not using modals to input reference,...
        if (
          !this.useModalInApplicationForm &&
          this.mapDependentObjects[dialogSection.label]
        ) {
          let listFields = dialogSection.list_fields;
          const listExcludeModels = [
            ...dialogSection.listModelsAdminOnly,
            ...dialogSection.listModelsAdminClient,
          ];
          listFields = listFields.filter(
            (field) => !listExcludeModels.includes(field.model)
          );
          // Check all fields are filled
          for (const sectionContent of this.mapDependentObjects[
            dialogSection.label
          ]) {
            const errorInfo = this.hasInvalidField(
              sectionContent,
              listFields,
              this.$store.getters.isAgent
            );
            if (errorInfo) {
              this.showErrorDialog({
                key: "INVALID_INPUT_ERROR",
                params: [this.getErrorMessage(errorInfo)],
              });
              console.log("Invalid field Agent only", sectionContent);
              return true;
            }
          }
        }
      }
      return false;
    },
    checkMissingJobBookingObject() {
      // Find builder for job booking
      const bookingBuilder = this.listDialogSections.find(
        (dialogSection) => dialogSection.name === "Booking"
      );
      if (bookingBuilder == null) {
        return false;
      }
      // Validate if bookingBuilder corresponding with current step (in case of multi-steps form)
      if (this.profile.is_multi_steps_form) {
        if (bookingBuilder.stepIndex !== this.currentStep) {
          return false;
        }
      }
      // Min count is not defined
      if (!this.getMinCount(bookingBuilder)) {
        return false;
      }
      if (this.listBookingJobs.length < bookingBuilder.minCount) {
        this.showMissingDependencyError(bookingBuilder);
        return true;
      }
      return false;
    },
    showMissingDependencyError(builder) {
      const content = this.tryGet(() => builder.additionalInformation.missing_required_items_error);
      if (content && content.length > 10) {
        this.showErrorDialog({
          innerHtml: content
        })
        return
      }
      let label = builder.label;
      if (builder.minCount == 1) {
        label = this.convertToSingularForm(builder.label);
      }
      this.showErrorDialog({
        key: 'MISSING_DEPENDENCY_OBJECT_ERROR',
        params: [label, builder.minCount],
      });
    },
    checkMissingSignDocument() {
      let listSignDocumentField = this.listSignDocumentField;
      // Get field which corresponding with current step
      if (this.profile.is_multi_steps_form) {
        listSignDocumentField = listSignDocumentField.filter(
          (field) => field.stepIndex === this.currentStep
        );
      }
      // Check no sign field
      if (listSignDocumentField.length === 0) {
        return false;
      }
      for (const signField of listSignDocumentField) {
        const signatures = this.mapSignatures[signField.label];
        if (signatures == null) {
          this.showErrorDialog(this.$store.getters.missingSignatureError);
          return true;
        }
      }
      return false;
    },
    checkMissingEvaluation() {
      let listEvaluationField = this.listEvaluationField;
      // Get field which corresponding with current step
      if (this.profile.is_multi_steps_form) {
        listEvaluationField = listEvaluationField.filter(
          (field) => field.stepIndex === this.currentStep
        );
      }
      // Check no sign field
      if (listEvaluationField.length === 0) {
        return false;
      }
      if (!this.listEvaluation) {
        this.showErrorDialog("MISSING_EVALUATION_ERROR");
        return true;
      }
      for (const evaluationField of listEvaluationField) {
        const evaluation = this.listEvaluation.find(
          (evaluation) =>
            evaluation.template_id === evaluationField.evaluationTemplateId
        );
        if (evaluation == null) {
          this.showErrorDialog("MISSING_EVALUATION_ERROR");
          return true;
        }
      }
      return false;
    },
    checkMissingFileWithInfo() {
      // Get file with info field which corresponding with current step
      let listFileInfoFields = this.listFileInfoFields;
      if (this.profile.is_multi_steps_form) {
        listFileInfoFields = listFileInfoFields.filter(
          (field) => field.stepIndex === this.currentStep
        );
      }
      // Check no file with info field
      if (listFileInfoFields.length === 0) {
        return false;
      }
      for (const fileInfoField of listFileInfoFields) {
        if (
          !this.isItemShow(this.applicationData, fileInfoField, this.listFields)
        ) {
          continue;
        }
        const fileInfo = this.mapFileInfo[fileInfoField.label];
        // Validate required file is uploaded
        if (fileInfoField.isRequired) {
          if (
            !(fileInfo && fileInfo.length && fileInfo[0] && fileInfo[0].url)
          ) {
            this.showErrorDialog({
              key: "INVALID_INPUT_ERROR",
              params: [`Field Require: ${fileInfoField.label}`],
            });
            console.log("Require file with info", fileInfoField);
            return true;
          }
        }
      }
      return false;
    },
    handleClickPreviousButton() {
      this.currentStep = this.currentStep - 1;
      this.isClickPrevious = true;
      this.$store.dispatch("setApplicationStateData", this.$data);
      this.$router.replace({
        name: "Application Form Builder",
        query: {
          step: this.currentStep,
        },
      });
    },
    // Check if all options of checkboxes are checked
    isAllCheckboxOptionsChecked(field) {
      if (!this.applicationData[field.model]) {
        // No option is checked
        console.log("false");
        console.log(field.model);
        console.log(this.applicationData);
        return false;
      }
      const optionList = this.normalizedArrayValue(field.optionList);
      for (const option of optionList) {
        if (!this.applicationData[field.model].includes(option)) {
          console.log(option);
          // Option is unchecked
          return false;
        }
      }
      return true;
    },
    async handleClickNextButton() {
      // Check precondition checkboxes are checked
      const listPreconditionCheckboxFields = this.listDisplayFields.filter(
        (field) =>
          field.isPreconditionCheck && [FORM_TYPE.CHECKBOX].includes(field.type)
      );
      if (listPreconditionCheckboxFields.length) {
        for (const preconditionCheckboxField of listPreconditionCheckboxFields) {
          if (!this.isAllCheckboxOptionsChecked(preconditionCheckboxField)) {
            // Show rejection message
            this.showErrorDialog({
              innerHtml: preconditionCheckboxField.rejectionMessage,
            });
            return;
          }
        }
      }
      this.submitClicked = true;
      // Check missing checkbox condition
      for (const key of Object.keys(this.mapCheckboxConditionStep)) {
        const step = this.mapCheckboxConditionStep[key];
        if (step !== this.currentStep) {
          continue;
        }
        if (this.mapCheckboxCondition[key] === false) {
          this.showErrorDialog({
            key: "INVALID_INPUT_ERROR",
            params: [`Field Require: ${key}`],
          });
          return;
        }
      }
      const errorInfo = this.hasInvalidField(
        this.applicationData,
        this.listDisplayFields
      );
      if (errorInfo) {
        this.showErrorDialog({
          key: "INVALID_INPUT_ERROR",
          params: [this.getErrorMessage(errorInfo)],
        });
        return;
      } else if (this.checkMissingDependencyObject()) {
        // For example: number of reference is not reach minimum number
        return;
      } else if (this.checkMissingJobBookingObject()) {
        return;
      } else if (this.checkMissingSignDocument()) {
        return;
      } else if (this.checkMissingEvaluation()) {
        return;
      } else if (this.checkMissingFileWithInfo()) {
        return;
      }
      if (this.paymentField && this.paymentField.stepIndex === this.currentStep) {
        const errorInfo = this.checkInvalidPaymentField();
        if (errorInfo) {
          this.showErrorDialog({
            key: "INVALID_INPUT_ERROR",
            params: [this.getErrorMessage(errorInfo)],
          });
          return;
        }
        const isSetPaymentMethod = await this.setStripePaymentMethod();
        if (!isSetPaymentMethod) {
          return
        }
      }
      this.setUserType(this.applicationData);
      const res = await axios.post("/validate-application-form/", {
        ...this.applicationData,
        user_id: this.registeredUserId,
      });
      if (!res || !res.data) {
        return;
      }
      this.submitClicked = false;
      this.currentStep = this.currentStep + 1;
      this.isClickPrevious = false;
      this.$store.dispatch("setApplicationStateData", this.$data);
      this.$router.replace({
        name: "Application Form Builder",
        query: {
          step: this.currentStep,
        },
      });
    },
    async setStripePaymentMethod() {
      // Check payment field
      if (!this.hasStripePayment) {
        return true;
      }
      if (!this.$refs.stripePayment) {
        return true;
      }
      // Create Stripe payment method
      const emptyPaymentEl = document.getElementById(
        STRIPE_PAYMENT_ERROR_IDS.EMPTY
      );
      const isACH = document.getElementById("ach-description");
      // Check if payment element is not empty
      if (isACH || !emptyPaymentEl) {
        const paymentMethodId =
          await this.$refs.stripePayment.createPaymentMethod();
        if (!paymentMethodId) {
          return false;
        }
        this.stripePaymentMethodId = paymentMethodId;
      }
      return true;
    },
    submitAuthorizePayment() {
      return new Promise(async (resolve) => {
        // Check all payment information is filled
        if (!this.authorizePaymentInfo) {
          resolve(true);
          return;
        }
        for (const model of this.listRequiredModelAuthorizePayment) {
          if (!this.authorizePaymentInfo[model]) {
            resolve(true);
            return;
          }
        }
        const authData = {
          clientKey: this.clientKey,
          apiLoginID: this.apiLoginID,
        };
        const cardData = { ...this.authorizePaymentInfo };
        let fullName = "";
        if (cardData.firstName) {
          fullName = cardData.firstName;
        }
        if (cardData.lastName) {
          fullName = fullName + " " + cardData.lastName;
        }
        fullName = fullName.trim();
        if (fullName) {
          cardData.fullName = fullName;
        }
        const secureData = {
          authData: authData,
          cardData: this.authorizePaymentInfo,
        };
        Accept.dispatchData(secureData, (response) => {
          if (response.opaqueData) {
            this.authorizeOpaqueData = response.opaqueData;
            resolve(true);
            return;
          }
          console.log(response);
          if (this.paymentField.isRequired) {
            if (response && response.messages && response.messages.message) {
              this.showErrorDialog({
                key: "INVALID_PAYMENT_INFORMATION",
                params: [
                  response.messages.message
                    .map((message) => `${message.code}: ${message.text}`)
                    .join(", "),
                ],
              });
              resolve(false);
              return;
            } else {
              this.showErrorDialog({
                key: "INVALID_PAYMENT_INFORMATION",
                params: [String(response)],
              });
              resolve(false);
              return;
            }
          }
          this.authorizeOpaqueData = null;
          resolve(true);
        });
      });
    },
    getBookingAmountPayment() {
      if (this.$refs.bookingSection && this.$refs.bookingSection.length) {
        let amount = 0;
        if (this.includeCandidatePayment) {
          amount = this.$refs.bookingSection[0].getTotalFee();
        } else {
          amount = this.$refs.bookingSection[0].getAgencyFee();
        }
        return amount;
      }
      return 0;
    },
    getNumberOfBookings() {
      // Count total number of bookings
      if (!this.listBookingJobs) {
        return 0;
      }
      let result = 0;
      for (const booking of this.listBookingJobs) {
        result += this.getListDateOfRepeatBooking(booking).length;
      }
      return result;
    },
    showCheckPaymentResult() {
      const paymentExpression =
        this.profile.additional_information.payment_expression;
      if (paymentExpression) {
        let payment = this.calcEval(
          "(function() {" +
            this.replaceTagValue(
              paymentExpression,
              {
                ...this.applicationData,
                number_booking: this.getNumberOfBookings(),
              },
              false,
              [],
              true
            ) +
            "}())"
        );
        this.addDiscountInfo(payment);
        this.showResultDialog({
          innerHtml: `<h2>Payment Expression Result</h2><p>${JSON.stringify(
            payment
          )}</p>`,
        });
      }
    },
    // Get stripe discount object
    // {coupon: counpon_id} or {promotion_code: code_id}
    addDiscountInfo(payment) {
      if (!payment) {
        return;
      }
      if (this.applicationData.promo_code && this.profile.promo_codes) {
        for (const code of this.profile.promo_codes) {
          if (code.code === this.applicationData.promo_code) {
            if (code.type === "Stripe Promotion Code") {
              if (payment.subscription) {
                payment.subscription.promotion_code = code.codeID;
                return;
              }
              if (payment.amount) {
                payment.promotion_code = code.codeID;
                return;
              }
            }
            if (code.type === "Stripe Coupon") {
              if (payment.subscription) {
                payment.subscription.coupon = code.couponID;
                return;
              }
              if (payment.amount) {
                payment.coupon = code.couponID;
                return;
              }
            }
          }
        }
      }
      return;
    },
    async submitApplication() {
      if (this.hasCaptcha) {
        if (!this.isVerifiedCaptcha) {
          this.showErrorDialog("CAPTCHA_NOT_COMPLETED");
          return;
        }
      }
      // Convert email fields to lower case
      if (this.applicationData.email) {
        this.applicationData.email = this.applicationData.email.toLowerCase();
      }
      if (this.applicationData.email2) {
        this.applicationData.email2 = this.applicationData.email2.toLowerCase();
      }
      this.submitClicked = true;
      const errorInfo = this.checkInvalidFields();
      if (errorInfo) {
        this.showErrorDialog({
          key: "INVALID_INPUT_ERROR",
          params: [this.getErrorMessage(errorInfo)],
        });
        return;
      } else if (this.checkMissingDependencyObject()) {
        // For example: number of reference is not reach minimum number
        return;
      } else if (this.checkMissingJobBookingObject()) {
        return;
      } else if (this.checkMissingSignDocument()) {
        return;
      } else if (this.checkMissingEvaluation()) {
        return;
      } else if (this.checkMissingFileWithInfo()) {
        return;
      }
      if (this.hasDuplicatedEmailError) {
        this.showErrorDialog({
          ...this.getDuplicatedEmailWarning(this.applicationData.email),
          onClickContent: this.handleClickDuplicatedWarningContent,
        });
        return;
      }
      // Submit Authorize payment information
      if (this.hasAuthorizePayment) {
        const isValid = await this.submitAuthorizePayment();
        if (!isValid) {
          return;
        }
      }
      const errorMessage = this.getErrorFromCondition(
        this.listErrorConditions,
        this.applicationData
      );
      if (errorMessage) {
        this.showErrorDialog({
          ...this.$store.getters.inputConditionError,
          message: errorMessage,
        });
        return;
      }
      if (!this.applicationData.email) {
        this.applicationData.email = this.generatePlaceholderEmail(
          this.applicationData
        );
      }

      this.registerUser();
    },
    getConditionString(condition) {
      const listTexts = [];
      try {
        const listConditions = condition.conditions.listConditions;
        listConditions.forEach((condition) => {
          const field = this.listFields.find(
            (field) => field.model === condition.model
          );
          if (!field) {
            return;
          }
          console.log(field.label);
          console.log(condition);
          listTexts.push(
            `${field.label} ${(condition.operator || "").toLowerCase()} ${
              condition.value
            }`
          );
        });
        return listTexts.join("\n");
      } catch (e) {
        console.log(e);
        return "";
      }
    },
    setUserType(obj) {
      if (this.type === BUILDER_USER_TYPE.UNSPECIFIED) {
        obj.is_candidate =
          this.applicationData.userType === this.candidateOption;
        obj.is_employer = this.applicationData.userType === this.clientOption;
        let builderId;
        if (obj.is_candidate) {
          builderId = this.tryGet(
            () =>
              this.profile.additional_information.application_builder_candidate
          );
        } else {
          builderId = this.tryGet(
            () => this.profile.additional_information.application_builder_client
          );
        }
        if (builderId) {
          obj.application_form = builderId;
          obj.original_contact_form = Number(this.$route.params.profileID);
        }
      } else {
        obj.is_candidate = this.type === BUILDER_USER_TYPE.CANDIDATE;
        obj.is_employer = this.type === BUILDER_USER_TYPE.CLIENT;
      }
    },
    // Calculate charge amount for authorize.net/quickbooks payments
    calculateChargeAmount(totalBookingFee) {
      let amount = 0;
      let hasPaymentExpression = false;
      // Check if price expression is used
      if (this.profile.additional_information) {
        const paymentExpression =
          this.profile.additional_information.payment_expression;
        if (paymentExpression) {
          hasPaymentExpression = true;
          amount = this.calcEval(
            "(function() {" +
              this.replaceTagValue(
                paymentExpression,
                {
                  ...this.applicationData,
                  number_booking: this.listBookingJobs
                    ? this.listBookingJobs.length
                    : 0,
                },
                false,
                [],
                true
              ) +
              "}())"
          );
        }
      }
      if (!hasPaymentExpression) {
        if (this.paymentField.chargeAmount) {
          amount = this.paymentField.chargeAmount;
        } else if (totalBookingFee) {
          amount = totalBookingFee;
        }
      }
      return amount;
    },
    async registerUser() {
      const hasBookingSection = this.listDialogSections.some(field => field.type === FORM_TYPE.BOOKING_SECTION);
      // Calculate total booking fee
      let totalBookingFee = 0;
      if (this.chargeClientWhenBooking) {
        totalBookingFee = this.getBookingAmountPayment();
      }
      let status = "Applied";
      if (this.profile.status_change) {
        status = this.profile.status_change;
      }
      if (this.type === BUILDER_USER_TYPE.UNSPECIFIED) {
        const userType = this.applicationData.userType;
        if (userType === this.candidateOption) {
          const candidateStatus = this.getAdditionalInfo(
            "status_change_candidate"
          );
          if (candidateStatus) {
            status = candidateStatus;
          }
        } else if (userType === this.clientOption) {
          const clientStatus = this.getAdditionalInfo("status_change_client");
          if (clientStatus) {
            status = clientStatus;
          }
        }
      }
      if (
        this.isMatchCombinedConditions(
          this.listRejectConditions,
          this.applicationData
        )
      ) {
        status = "Rejected";
      }

      // Reset value of the fields which are not showed
      for (const model of Object.keys(this.applicationData)) {
        this.resetValueOfHiddenField(
          this.applicationData,
          this.applicationData,
          this.listFields,
          model
        );
      }

      // Check to autofill location if there is only one location
      if (this.listLocations && this.listLocations.length === 1) {
        this.applicationData["locations"] = [...this.listLocations];
      }

      // Calculate membership info
      const membershipInfo = this.getMembershipInfoFromCondition(
        this.listMembershipConditions,
        this.applicationData
      );

      // Calculate type
      const userTypes = this.calculateUserProperties(
        this.listTypeConditions,
        this.applicationData,
        this.applicationData.types,
        "type"
      );

      userTypes.push.apply(userTypes, this.profile.user_types_on_registration); // If certain user types are always set for this application form https://stackoverflow.com/questions/4842993/javascript-push-an-entire-list

      this.userTypes = userTypes;
      // Calculate user tags
      const userTags = this.calculateUserProperties(
        this.listTagConditions,
        this.applicationData,
        this.applicationData.tags,
        "tag"
      );

      // Calculate conditional status
      const conditionalStatusObject = this.calculateUserProperty(
        this.listStatusConditions,
        this.applicationData,
        "status"
      );
      let conditionalStatus = null;
      if (conditionalStatusObject && conditionalStatusObject.status) {
        conditionalStatus = conditionalStatusObject.status;
      }
      if (conditionalStatus) {
        status = conditionalStatus;
      }

      const conditionalSecondStatusObject = this.calculateUserProperty(
        this.listSecondStatusConditions,
        this.applicationData,
        "second_status"
      );
      let conditionalSecondStatus = null;
      if (
        conditionalSecondStatusObject &&
        conditionalSecondStatusObject.second_status
      ) {
        conditionalSecondStatus = conditionalSecondStatusObject.second_status;
      }

      // Create request body
      let requestBody = {
        ...this.applicationData,
        types: userTypes,
        tags: userTags,
        membership_info: membershipInfo,
        status: status,
        password: this.applicationData.password
          ? this.applicationData.password
          : this.applicationData.email,
        application_content: this.getApplicationEmailContent(
          this.applicationData,
          this.listFields,
          this.mapDependentObjects,
          this.listBookingJobs,
          this.isOneItemPerRow
        ),
        url: this.rootUrl,
      };

      const secondStatus = this.secondStatusChangeTo || conditionalSecondStatus;
      if (secondStatus) {
        requestBody.second_status = secondStatus;
      }

      if (!requestBody.locations || !requestBody.locations.length) {
        if (this.listLocationConditions && this.listLocationConditions.length) {
          // Calculate user locations
          const userLocations = this.calculateUserProperties(
            this.listLocationConditions,
            this.applicationData,
            this.applicationData.locations,
            "location"
          );
          requestBody.locations = userLocations;
        }
      }
      if (!requestBody.admin_manager) {
        if (this.listManagerConditions && this.listManagerConditions.length) {
          // Calculate user locations
          const listAdminManager = this.calculateUserProperties(
            this.listManagerConditions,
            this.applicationData,
            null,
            "admin_manager"
          );
          if (listAdminManager && listAdminManager.length) {
            requestBody.admin_manager = listAdminManager[0];
          }
        }
      }

      if (!requestBody.second_admin_manager) {
        if (
          this.listSecondManagerConditions &&
          this.listSecondManagerConditions.length
        ) {
          // Calculate user locations
          const listAdminManager = this.calculateUserProperties(
            this.listSecondManagerConditions,
            this.applicationData,
            null,
            "second_admin_manager"
          );
          if (listAdminManager && listAdminManager.length) {
            requestBody.second_admin_manager = listAdminManager[0];
          }
        }
      }

      if (this.listChecklistConditions && this.listChecklistConditions.length) {
        // Calculate user checklist
        const userChecklist = this.calculateUserProperties(
          this.listChecklistConditions,
          this.applicationData,
          this.applicationData.checklist,
          "admin_checklist"
        );
        if (userChecklist && userChecklist.length) {
          requestBody.checklist = userChecklist;
        }
      }

      if (this.listBadgeConditions && this.listBadgeConditions.length) {
        // Calculate user badge
        const userBadges = this.calculateUserProperties(
          this.listBadgeConditions,
          this.applicationData,
          [],
          "badge"
        );
        if (userBadges && userBadges.length) {
          requestBody.badges = userBadges;
        }
      }

      // Update value of derived model
      this.updateDerivedModel(requestBody, this.listFields);

      // User type
      this.setUserType(requestBody);
      if (this.hasAuthorizePayment && this.authorizeOpaqueData) {
        requestBody["authorize_opaque_data"] = this.authorizeOpaqueData;
        const amount = this.calculateChargeAmount(totalBookingFee);
        if (amount) {
          requestBody["charge_amount"] = amount;
        }
      }
      if (this.hasQuickbooksPayment && this.quickbooksPaymentInfo) {
        requestBody["quickbooks_payment_info"] = this.quickbooksPaymentInfo;
        const amount = this.calculateChargeAmount(totalBookingFee);
        if (amount) {
          requestBody["charge_amount"] = amount;
        }
      }

      // Calculate keap tag IDs
      if (
        this.profile.additional_information &&
        this.profile.additional_information.add_to_keap
      ) {
        const keapTagIds1 = this.profile.additional_information.keap_tag_ids;
        const tagIds = this.calculateUserProperties(
          this.listKeapTagConditions,
          this.applicationData,
          null,
          "keap_tag"
        );
        const keapTagIds2 = tagIds.join(",");

        // Keap tag id is combined of keap tag 1 and keap tag 2
        const keapTagIds = this.concatStrings(keapTagIds1, keapTagIds2, ",");

        if (keapTagIds) {
          requestBody["keap_tag_ids"] = keapTagIds;
        }
      }

      // Correct format for time picker fields
      for (const field of this.listFields) {
        if (field.type === FORM_TYPE.TIME_PICKER) {
          if (
            field.model &&
            requestBody[field.model] &&
            typeof requestBody[field.model] === "object"
          ) {
            requestBody[field.model] = this.getTimeString(
              requestBody[field.model]
            );
          }
        }
      }

      // Find data for custom keap field
      this.attachKeapInfo(
        requestBody,
        this.profile.additional_information,
        this.listFields,
        this.applicationData
      );

      const listFileFields = [];
      for (const fileModel of this.listFileModels) {
        if (this.applicationData[fileModel]) {
          listFileFields.push({
            model: fileModel,
            type: "people",
            file: this.applicationData[fileModel],
            url: this.applicationData[fileModel],
          });
          delete requestBody[fileModel];
        }
      }

      // Dependent data: Experience, Children, Pet, Reference, Contact, Education
      const mapDialogSectionByLabel = {};
      this.listDialogSections.forEach((dialogSection) => {
        mapDialogSectionByLabel[dialogSection.label] = dialogSection;
      });

      const listKeapSectionInfo = []; // List of section which need to be added to keap

      for (const dependentName in this.mapDependentObjects) {
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]].apiKey
        );
        if (apiKey) {
          delete requestBody[apiKey];
        }
      }

      for (const dependentName in this.mapDependentObjects) {
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]].apiKey
        );
        const listDependentObjects = this.mapDependentObjects[dependentName];
        if (!mapDialogSectionByLabel[dependentName]) {
          continue;
        }
        // Check if add to keap
        if (
          mapDialogSectionByLabel[dependentName].additionalInformation &&
          mapDialogSectionByLabel[dependentName].additionalInformation
            .add_to_keap
        ) {
          const keapSectionInfo = {
            name: apiKey,
          };
          const relationship =
            mapDialogSectionByLabel[dependentName].additionalInformation
              .relationship;
          if (relationship) {
            keapSectionInfo.relationship = relationship;
          }
          listKeapSectionInfo.push(keapSectionInfo);
        }
        const sectionListFields =
          mapDialogSectionByLabel[dependentName].list_fields;
        const sectionListFileModels = sectionListFields
          .filter((field) => field.type === FORM_TYPE.FILE)
          .map((field) => field.model);
        // Use a cloned variable to avoid reference variable
        const listDependentObjectRequests = [];
        for (let index = 0; index < listDependentObjects.length; index++) {
          const dependentObject = listDependentObjects[index];
          if (!dependentObject.type) {
            dependentObject.type = dependentName;
          }
          const clonedObject = { ...dependentObject };
          if (clonedObject.id == 0) {
            delete clonedObject.id;
          }
          for (const sectionFileModel of sectionListFileModels) {
            if (dependentObject[sectionFileModel]) {
              listFileFields.push({
                model: sectionFileModel,
                type: apiKey,
                index: index,
                label: dependentName,
                file: dependentObject[sectionFileModel],
              });
              delete clonedObject[sectionFileModel];
            }
          }
          this.attachKeapInfo(
            clonedObject,
            mapDialogSectionByLabel[dependentName].additionalInformation,
            sectionListFields,
            clonedObject
          );
          listDependentObjectRequests.push(clonedObject);
        }
        if (requestBody[apiKey]) {
          requestBody[apiKey] = [
            ...requestBody[apiKey],
            ...listDependentObjectRequests,
          ];
        } else {
          requestBody[apiKey] = listDependentObjectRequests;
        }
      }

      requestBody.keap_section_info = listKeapSectionInfo;

      // List of fields will be submitted with the job
      // If those addresses field of job is undefined, it will be get from user
      const addressInfo = {};
      const listOtherModel = ["address1", "address2", "postal_code", "city"];
      listOtherModel.forEach((model) => {
        if (this.applicationData[model]) {
          addressInfo[model] = this.applicationData[model];
        }
      });
      if (hasBookingSection) {
        // Job Booking Information
        requestBody["jobs"] = this.listBookingJobs.map((job) => {
          return { ...addressInfo, ...job };
        });
      }

      // Signing document
      requestBody["documents"] = this.getSigningDocuments();

      // File with info
      this.setFileWithInfo(requestBody);

      if (listFileFields.length) {
        // Check user existance
        const isExisted = await this.checkUserExistance();
        if (isExisted) {
          this.showConfirmDialog({
            innerHtml:
              this.$store.getters.agencyPublic.duplicate_email_error_message,
            acceptLabel: "Navigate to Login",
            rejectLabel: "Edit the form",
            onAcceptCallback: () => this.$router.replace({ name: "Login" }),
          });
          return;
        }
        // Submit files
        const formData = new FormData();
        let hasFile = false;
        for (let index = 0; index < listFileFields.length; index++) {
          const fileField = listFileFields[index];
          if (fileField.url) {
            continue;
          }
          if (typeof fileField.file === "string") {
            if (fileField.file.includes("user_upload_files")) {
              fileField.url = fileField.file;
              continue;
            }
          }
          hasFile = true;
          formData.append(index, fileField.file);
        }
        if (hasFile) {
          formData.append("agency", this.agencyID);
          formData.append("profile-builder", this.profileID);
          formData.append("email", this.applicationData.email);
          try {
            const uploadFileRes = await axios.post(`/upload-files/`, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            });
            if (uploadFileRes && uploadFileRes.data) {
              for (let index = 0; index < listFileFields.length; index++) {
                const fileField = listFileFields[index];
                if (uploadFileRes.data[index]) {
                  const filePath = uploadFileRes.data[index];
                  fileField.url = filePath;
                }
              }
            }
          } catch (e) {
            console.log(e);
          }
        }
        // Check to add document to keap
        if (
          this.profile.additional_information &&
          this.profile.additional_information.add_document_to_keap
        ) {
          if (listFileFields && this.$store.getters.mapUploadedFileUrlName) {
            for (const fileField of listFileFields) {
              if (fileField.url) {
                const fileName =
                  this.$store.getters.mapUploadedFileUrlName[fileField.url];
                if (fileName) {
                  fileField.file_name = fileName;
                }
              }
            }
          }
        }
        requestBody.file_urls = listFileFields;
      }

      let payment = null;
      if (this.hasStripePayment) {
        const isSetPaymentMethod = await this.setStripePaymentMethod();
        if (!isSetPaymentMethod) {
          return;
        }
        if (this.stripePaymentMethodId) {
          requestBody.payment_method = this.stripePaymentMethodId;
        }
        if (totalBookingFee) {
          payment = { amount: totalBookingFee, chargeBookingFee: true, description: "Charge booking fee" };
        } else if (
          this.applicationData.credit_package &&
          !this.isMonthlyCreditPackageSelection
        ) {
          payment = {
            amount: Number(this.applicationData.credit_package.price),
            chargeCreditPackage: true,
            description: `Charge for ${this.applicationData.credit_package.credits} credits`
          };
        }
        if (this.profile.additional_information) {
          const paymentExpression =
            this.profile.additional_information.payment_expression;
          if (paymentExpression) {
            const paymentExpressionVal = this.calcEval(
              "(function() {" +
                this.replaceTagValue(
                  paymentExpression,
                  {
                    ...this.applicationData,
                    number_booking: this.getNumberOfBookings(),
                  },
                  false,
                  [],
                  true
                ) +
                "}())"
            );
            if (paymentExpressionVal) {
              payment = paymentExpressionVal;
              // Charge later
              if (payment && payment.amount) {
                if (
                  (this.chargeOn === "create_booking" &&
                    !(this.listBookingJobs && this.listBookingJobs.length)) ||
                  this.chargeOn === "assign_candidate"
                ) {
                  requestBody.charge_info = {
                    amount: payment.amount,
                    charge_on: this.chargeOn,
                  };
                  payment = null;
                }
              }
            }
          }
        }
        if (
          this.stripeSubscriptionSelected &&
          this.stripeSubscriptionSelected.planId
        ) {
          if (!payment) {
            payment = {};
          }
          payment.subscription = {
            plan_id: this.stripeSubscriptionSelected.planId,
            fee_percentage: 0,
            tax_percentage: 0,
          };
          requestBody.info__stripe_subscription_selected = this.stripeSubscriptionSelected;
        }
      }

      // Check if create week availabilities
      this.setWeekAvailabilities(requestBody);
      if (this.registeredUserId) {
        requestBody.tracking_id = this.registeredUserId;
      }

      if (this.listEvaluation && this.listEvaluation.length) {
        requestBody.evaluations = this.listEvaluation;
      }
      if (this.isEmbed && this.redirectToLink) {
        this.showResultDialog({
          title: "Thank you, please wait!",
          noToast: true,
          hideButton: true,
        });
      }

      if (this.isBookingOnly) {
        requestBody = {
          poster: requestBody.tracking_id,
          jobs: requestBody.jobs,
          application_form: requestBody.application_form,
          create_jobs: true,
        };
      }

      // Submit Stripe payment
      if (this.hasStripePayment) {
        const emptyPaymentEl = document.getElementById(
          STRIPE_PAYMENT_ERROR_IDS.EMPTY
        );
        // Check if payment element is not empty
        if (!emptyPaymentEl) {
          this.addDiscountInfo(payment);
        }
        requestBody.payment_detail = payment;
      }

      if (this.applicationData.credit_package) {
        requestBody.is_monthly_credit_package_selection =
          this.isMonthlyCreditPackageSelection;
      }

      // Send create user request
      const res = await axios.post("/application-submit/", requestBody);
      if (res && res.data) {
        if (this.isEmbed && this.redirectToLink) {
          this.hideResultDialog();
        }
        this.initialLoggedInUser = null;
        if (this.isBookingOnly) {
          this.showResultDialog("BOOKING_SUBMITTED_RESULT_DIALOG");
          return;
        }
        if (this.intervalSubmitFunc) {
          clearInterval(this.intervalSubmitFunc);
        }

        // Handle status change
        await this.handleAfterUserStatusChanged(
          { ...res.data, types: userTypes },
          status,
          null,
          conditionalStatus
            ? {
                reason:
                  "Set Conditional Status in Application Form\n" +
                  this.getConditionString(conditionalStatusObject),
              }
            : null,
          false,
          true
        );

        if (secondStatus) {
          await this.handleAfterUserStatusChanged(
            { ...res.data, types: userTypes },
            secondStatus,
            null,
            {
              reason:
                "Set Conditional Second Status in Application Form\n" +
                this.getConditionString(conditionalSecondStatusObject),
            },
            true,
            true
          );
        }

        this.userStatus = status;

        if (status === "Rejected") {
          if (this.redirectToLink) {
            this.showResultDialog({
              ...this.submitRejectDialog,
              onCloseCallback: () => {
                window.top.location.href = this.redirectToLink;
              },
            });
            if (this.rejectionMessageDuration) {
              setTimeout(() => {
                this.hideResultDialog();
                window.top.location.href = this.redirectToLink;
              }, Number(this.rejectionMessageDuration) * 1000);
            }
          } else {
            this.showResultDialog(this.submitRejectDialog);
          }
        } else {
          let label = "Close";
          if (this.profile.redirect_to_dashboard_on_registration) {
            label = "Continue";
          }
          if (this.redirectToLink) {
            if (this.redirectImmediately) {
              window.top.location.href = this.redirectToLink;
              return;
            }
            if (
              this.submissionMessageDuration &&
              Number(this.submissionMessageDuration)
            ) {
              this.showResultDialog({
                ...this.submitSuccessDialog,
                closeLabel: label,
                onCloseCallback: this.onCloseResultDialog,
              });
              setTimeout(() => {
                this.hideResultDialog();
                window.top.location.href = this.redirectToLink;
              }, Number(this.submissionMessageDuration) * 1000);
            } else {
              if (
                this.submissionMessageDuration &&
                !Number(this.submissionMessageDuration)
              ) {
                // No submission confirmation message
                this.showResultDialog({
                  title: "Thank you, please wait!",
                  noToast: true,
                  hideButton: true,
                });
                setTimeout(() => {
                  this.hideResultDialog();
                  window.top.location.href = this.redirectToLink;
                }, 1000);
              } else {
                this.showResultDialog({
                  ...this.submitSuccessDialog,
                  closeLabel: label,
                  onCloseCallback: this.onCloseResultDialog,
                });
              }
            }
            return;
          } else {
            this.showResultDialog({
              ...this.submitSuccessDialog,
              closeLabel: label,
              onCloseCallback: this.onCloseResultDialog,
            });
          }
        }

        if (!this.redirectToLink) {
          // Login
          await this.handleLogin({
            email: requestBody.email,
            password: requestBody.password,
            user_type:
              this.type === BUILDER_USER_TYPE.CLIENT ? "employer" : "candidate",
            agency: this.agencyID,
          });

          if (
            this.profile.redirect_to_dashboard_on_registration &&
            !this.isEmbed
          ) {
            // this.$store.dispatch("getAgency", this.agencyID);
            this.dashboardRedirect();
          }
        }
      } else {
        if (this.isEmbed && this.redirectToLink) {
          // Hide result (Thank you, please wait) to show error
          this.hideResultDialog();
        }
      }
    },
    parseTimeString(input) {
      /* Parse time from String to Object
        Input: '00:11:AM
        Output: {hh: 00, mm: 11, A: AM}
      */
      const tokens = input.split(":");
      if (tokens.length != 3) {
        return null;
      } else {
        return this.getTimeString({
          hh: tokens[0],
          mm: tokens[1],
          A: tokens[2],
        });
      }
    },
    setWeekAvailabilities(requestBody) {
      const field = this.listFields.find(
        (field) => field.populateWeekAvailabilities
      );
      if (!field || !field.listDays) {
        return;
      }
      const inputArr = this.applicationData[field.model];
      if (!inputArr) {
        return;
      }
      const listDays = field.listDays.split("\n").map((item) => item.trim());
      const mapAvailability = {};
      for (const index in inputArr) {
        const val = inputArr[index];
        if (val) {
          let fromToTokens;
          if (val.includes(TIME_FROM_TO_SEPARATOR)) {
            // New data is separated by tab (use with Textbox)
            fromToTokens = val.split(TIME_FROM_TO_SEPARATOR);
          } else {
            if (!field.useTimePicker) {
              // Old data is separated by comma (use with Timepicker)
              const mapReplacedValues = {
                ":AM": " AM",
                ":PM": " PM",
              };
              fromToTokens = this.replaceAllByMap(val, mapReplacedValues).split(
                ","
              );
            }
            fromToTokens = val.split(",");
            // Only get first 2 items
            fromToTokens = fromToTokens.slice(0, 2);
          }
          let from, to;
          // Parse from
          if (field.useTimePicker) {
            if (fromToTokens[0]) {
              from = this.parseTimeString(fromToTokens[0]);
            }
            if (fromToTokens[1]) {
              to = this.parseTimeString(fromToTokens[1]);
            }
          }
          if (from && to) {
            mapAvailability[listDays[index].toLowerCase()] = [[from, to]];
          }
        }
      }
      requestBody.week_availabilities = mapAvailability;
    },
    checkUserExistance() {
      return new Promise(async (resolve) => {
        if (this.registeredUserId) {
          resolve(false);
          return;
        }
        const requestBody = {
          email: this.applicationData.email,
          agency_id: this.$store.getters.agencyID,
        };
        this.setUserType(requestBody);
        const res = await axios.post(`/check-user-existence/`, requestBody);
        if (!res.data) {
          resolve(false);
          return;
        }
        // If user existed, and status is not in reapplication_statuses, return code is 2
        resolve(res.data.code === 2);
      });
    },
    getSigningDocuments() {
      if (this.listSignDocumentField.length === 0) {
        return [];
      }
      const result = [];
      for (const signField of this.listSignDocumentField) {
        if (!this.mapSignatures[signField.label]) {
          continue;
        }
        const template =
          this.mapDocumentTemplates[this.getKeySigningField(signField)];
        result.push({
          title: template.name,
          template: template.id,
          signing_user: this.$store.getters.userID,
          status: "Signed",
          ...this.mapSignatures[signField.label],
          signing_date: this.todayDatetimeDjangoFormat,
          fields_labels: template.fields,
          fields_required: template.fields_required,
          edit_access: template.edit_access,
          organization_signer: template.organization_signer,
          order: template.order,
          signer_labels: template.signer_labels,
          use_image: template.use_image,
          params: template.params,
          agency_owner: this.$store.getters.agencyName,
          agency: this.$store.getters.agencyID,
        });
      }
      return result;
    },

    onCloseResultDialog() {
      if (this.redirectToLink) {
        window.top.location.href = this.redirectToLink;
        return;
      }
      if (
        this.profile.additional_information &&
        this.profile.additional_information.open_on_close_result_section_id &&
        this.profile.redirect_to_dashboard_on_registration &&
        !this.isEmbed
      ) {
        this.$store.dispatch(
          "setOpenProfileSectionId",
          this.profile.additional_information.open_on_close_result_section_id
        );
      }
    },
    jobViewApplicationSubmitted() {
      // Update JobView item to show that an application was submitted
      if (this.jobViewID) {
        axios
          .patch(`/job-clicks/${this.jobViewID}`, {
            new_application_submitted: true,
          })
          .then((res) => {
            console.log("Job view object updated");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getMinCount(dialogSection) {
      if (dialogSection.notRequiredInApplication) {
        return null;
      }
      return dialogSection.minCount;
    },
    reloadApplicationData() {
      this.applicationData = { ...this.applicationData };
    },
    isShowDuplicatedWarning(model) {
      if (model === "email") {
        if (this.hideDuplicatedEmailWarning) {
          return false;
        }
      }
      if (model === "phone") {
        if (this.hideDuplicatedPhoneWarning) {
          return false;
        }
      }
      return true;
    },
    isDuplicatedUser(code) {
      if (code === 2) {
        return true;
      }
      if (
        code === 3 &&
        this.returningApplicantBtnField &&
        !this.registeredUserId
      ) {
        return true;
      }
      return false;
    },
    async handleBlurField(model) {
      if (model === "email") {
        this.hasDuplicatedEmailError = false;
      }
      // Check if email, phone is existed
      if (["email", "phone"].includes(model)) {
        if (this.isShowDuplicatedWarning(model)) {
          const requestBody = {
            country: this.applicationData.country,
            agency_id: this.$store.getters.agencyID,
            id: this.registeredUserId,
          };
          this.setUserType(requestBody);
          requestBody[model] = this.applicationData[model];
          const res = await axios.post(
            this.appendBackgroundParam(`/check-user-existence/`),
            requestBody
          );
          if (
            res &&
            res.data &&
            this.isDuplicatedUser(res.data.code) &&
            res.data.field
          ) {
            if (res.data.field === "email") {
              this.hasDuplicatedEmailError = true;
              this.showErrorDialog({
                ...this.getDuplicatedEmailWarning(
                  res.data.value || this.applicationData.email
                ),
                onClickContent: this.handleClickDuplicatedWarningContent,
              });
            } else if (res.data.field === "phone number") {
              this.showErrorDialog({
                ...this.getDuplicatedPhoneWarning(
                  res.data.value || this.applicationData.phone
                ),
                onClickContent: this.handleClickDuplicatedWarningContent,
              });
            }
          }
        }
        if (this.isTrackApplication) {
          this.submitTrackingApplicationData();
        }
      }
    },
    handleClickDuplicatedWarningContent(targetId) {
      if (targetId === "returning-application-button") {
        this.hideErrorDialog();
        this.handleClickReturningApplicantBtn();
      }
    },
    handleSubmitEvaluation(evaluationInfo) {
      if (evaluationInfo && evaluationInfo.template_id) {
        evaluationInfo.template = evaluationInfo.template_id;
        this.listEvaluation = this.listEvaluation.filter(
          (evaluation) => evaluation.template_id !== evaluationInfo.template_id
        );
        this.listEvaluation.push(evaluationInfo);
      }
    },
    async handleClickReturningApplicantBtn() {
      this.showInputDialog({
        title: "Email Address",
        listFields: [
          {
            label:
              "Please enter the email address you used to fill the application previously",
            model: "email",
          },
        ],
        onSubmitCallback: async (info) => {
          const requestBody = {
            agency: this.agencyID,
            email: info.email,
          };
          this.setUserType(requestBody);
          const res = await axios.post(
            `/generate-verification-code/`,
            requestBody
          );
          if (!res || !res.data) {
            return;
          }
          if (res.data.code === -1) {
            // User not found
            this.showErrorDialog("RETURNING_APPLICANT_EMAIL_NOT_FOUND");
            return;
          }
          this.showVerificationCodeInputDialog(info.email);
        },
      });
    },
    showVerificationCodeInputDialog(email) {
      this.showInputDialog({
        title: "Verification Code",
        listFields: [
          {
            label: `An email with a verification code has just been sent to ${email}. Please enter your verification code to continue.`,
            model: "code",
          },
        ],
        onSubmitCallback: async (info) => {
          const requestBody = {
            agency: this.agencyID,
            email: email,
            code: info.code,
          };
          this.setUserType(requestBody);
          const res = await axios.post(`/verify-code/`, requestBody);
          if (!res || !res.data) {
            return;
          }
          const userID = res.data.user_id;
          if (!userID) {
            this.showErrorDialog("RETURNING_APPLICANT_INCORRECT_CODE");
            return;
          }
          await this.loadPreApplication(userID);
          if (this.registeredUserId) {
            this.showResultDialog("RETURNING_APPLICANT_RESULT_DIALOG");
          }
        },
      });
    },
    async loadPreApplication(userID, hashID) {
      const res = await axios.post("/return-public-user/", {
        user_id: userID,
        id: hashID,
      });
      if (res && res.data && res.data.user) {
        const user = res.data.user;
        if (this.isValidPreApplicationUser(user)) {
          this.applicationData = {
            ...this.applicationData,
            ...this.extractSelectedFields(user, this.listFields, true),
            locations: user.locations,
            language: user.language,
          };
          for (const fileModel of this.listFileModels) {
            if (this.applicationData[fileModel]) {
              this.applicationData[fileModel] = this.convertToRelativePath(
                this.applicationData[fileModel]
              );
            }
          }
          if (this.isBookingOnly) {
            this.applicationData.first_name = user.first_name;
            this.applicationData.last_name = user.last_name;
            this.applicationData.email = user.email;
          }
          this.registeredUserId = user.id;
          this.preApplicationUserStatus = user.status;
          // Load existing references, experiences, ...
          const ampApiCounts = {};
          for (const dependentName in this.mapDependentObjects) {
            const apiKey = this.tryGet(
              () =>
                MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]]
                  .apiKey
            );
            if (apiKey) {
              const currentVal = ampApiCounts[apiKey] || 0;
              ampApiCounts[apiKey] = currentVal + 1;
            }
          }
          for (const dependentName in this.mapDependentObjects) {
            if (!dependentName) {
              continue;
            }
            const apiKey = this.tryGet(
              () =>
                MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]]
                  .apiKey
            );
            const label = dependentName.trim();
            if (apiKey && user[apiKey] && user[apiKey].length) {
              let listValues = user[apiKey];
              if (ampApiCounts[apiKey] > 1) {
                listValues = listValues.filter(
                  (item) => item.type && item.type.trim() == label
                );
              }
              this.mapDependentObjects[dependentName] = listValues;
            }
          }
          this.saveMapDependentObjects();
          // Load evaluations
          if (user.evaluations) {
            user.evaluations.forEach((evaluation) => {
              evaluation.template_id = evaluation.template;
              delete evaluation.id;
            });
            this.listOriginalEvaluations = user.evaluations;
            this.listEvaluation = [...this.listOriginalEvaluations];
          }
          this.saveListEvaluations();
          if (user.documents) {
            this.listOriginalDocuments = user.documents;
          }
          this.saveListDocuments(this.getSigningDocuments());
          if (user.files) {
            user.files.forEach((file) => {
              if (file.file_link) {
                file.url = this.convertToRelativePath(file.file_link);
              }
              delete file.file_link;
              delete file.user;
              delete file.agency;
            });
            this.listFileInfoFields.forEach((field) => {
              const listFiles = user.files.filter(
                (file) => file.name === field.label
              );
              this.mapFileInfo[field.label] = listFiles;
              this.saveMapFileInfo();
            });
          }
        }
        return user;
      }
    },
    setDependentData(requestBody) {
      // Dependent data: Experience, Children, Pet, Reference, Contact, Education
      const mapDialogSectionByLabel = {};
      const listFileFields = [];
      this.listDialogSections.forEach((dialogSection) => {
        mapDialogSectionByLabel[dialogSection.label] = dialogSection;
      });
      const mapOldObjects = this.mapSavedDependentObjects;

      for (const dependentName in this.mapDependentObjects) {
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]].apiKey
        );
        if (apiKey) {
          delete requestBody[apiKey];
        }
      }

      for (const dependentName in this.mapDependentObjects) {
        const apiKey = this.tryGet(
          () =>
            MAP_DIALOG_SECTION[this.mapDependentLabelName[dependentName]].apiKey
        );
        const listDependentObjects = this.mapDependentObjects[dependentName];
        if (!mapDialogSectionByLabel[dependentName]) {
          continue;
        }
        const listPreviousDependentObjects =
          this.tryGet(() => mapOldObjects[dependentName]) || [];

        const sectionListFields =
          mapDialogSectionByLabel[dependentName].list_fields;
        if (this.mapSectionAPICount[apiKey] <= 1) {
          if (
            this.isUnchangedList(
              listPreviousDependentObjects,
              listDependentObjects,
              sectionListFields
            )
          ) {
            continue;
          }
        }
        const sectionListFileModels = sectionListFields
          .filter((field) => field.type === FORM_TYPE.FILE)
          .map((field) => field.model);
        // Use a cloned variable to avoid reference variable
        const listDependentObjectRequests = [];
        for (let index = 0; index < listDependentObjects.length; index++) {
          const dependentObject = listDependentObjects[index];
          if (!dependentObject.type) {
            dependentObject.type = dependentName;
          }
          const clonedObject = { ...dependentObject };
          if (clonedObject.id == 0) {
            delete clonedObject.id;
          }
          for (const sectionFileModel of sectionListFileModels) {
            if (dependentObject[sectionFileModel]) {
              const fileValue = dependentObject[sectionFileModel];
              const fileObj = {
                model: sectionFileModel,
                type: apiKey,
                index: index,
                label: dependentName,
                file: fileValue,
              };
              if (typeof fileValue === "string") {
                fileObj.url = this.convertToRelativePath(fileValue);
              }
              listFileFields.push(fileObj);
              delete clonedObject[sectionFileModel];
            }
          }
          listDependentObjectRequests.push(clonedObject);
        }
        if (requestBody[apiKey]) {
          requestBody[apiKey] = [
            ...requestBody[apiKey],
            ...listDependentObjectRequests,
          ];
        } else {
          requestBody[apiKey] = listDependentObjectRequests;
        }
        requestBody.file_urls = listFileFields;
      }
      this.saveMapDependentObjects();
    },
    setFileWithInfo(requestBody) {
      // File with info
      let listFileInfo = [];
      let listSaveFileInfo = [];
      for (const fileInfoField of this.listFileInfoFields) {
        const saveFileInfos =
          this.tryGet(() => this.mapSavedFileInfo[fileInfoField.label]) || [];
        listSaveFileInfo = [...listSaveFileInfo, ...saveFileInfos];
        const fileInfos = this.mapFileInfo[fileInfoField.label];
        if (!fileInfos || !fileInfos.length) {
          continue;
        }
        listFileInfo = [...listFileInfo, ...fileInfos];
      }
      if (!this.isUnchangedList(listSaveFileInfo, listFileInfo)) {
        requestBody["files"] = listFileInfo;
      }
      this.saveMapFileInfo();
    },
    async submitTrackingApplicationData() {
      if (this.hasDuplicatedEmailError) {
        return;
      }
      if (!this.applicationData || !this.applicationData.email) {
        return;
      }
      // Convert email fields to lower case
      if (this.applicationData.email) {
        this.applicationData.email = this.applicationData.email.toLowerCase();
      }
      if (this.applicationData.email2) {
        this.applicationData.email2 = this.applicationData.email2.toLowerCase();
      }
      const requestBody = {
        ...this.applicationData,
        status: this.preApplicationUserStatus || this.applicationAbandonStatus,
        tracking_id: this.registeredUserId,
        is_tracking: true,
        password: this.applicationData.password || this.applicationData.email,
      };
      this.setUserType(requestBody);
      this.setDependentData(requestBody);
      if (this.listEvaluation && this.listEvaluation.length) {
        if (
          !this.isUnchangedList(this.listSavedEvaluations, this.listEvaluation)
        ) {
          requestBody.evaluations = this.listEvaluation;
        }
      }
      this.saveListEvaluations();
      // Signing document
      const listSignedDoc = this.getSigningDocuments();
      if (listSignedDoc && listSignedDoc.length) {
        if (!this.isUnchangedList(this.listSavedDocuments, listSignedDoc)) {
          requestBody["documents"] = listSignedDoc;
        }
      }
      this.saveListDocuments(listSignedDoc);

      // File field
      const listFileFields = [];
      for (const fileModel of this.listFileModels) {
        if (this.applicationData[fileModel]) {
          listFileFields.push({
            model: fileModel,
            type: "people",
            file: this.applicationData[fileModel],
            url: this.applicationData[fileModel],
          });
          delete requestBody[fileModel];
        }
      }
      if (listFileFields.length) {
        requestBody.file_urls = listFileFields;
      }
      this.setFileWithInfo(requestBody);

      const trackingRequest = JSON.stringify(requestBody);
      if (trackingRequest === this.lastTrackingRequest) {
        return;
      }
      this.lastTrackingRequest = trackingRequest;

      // Set type conditions
      // Calculate type
      if (this.listTypeConditions && this.listTypeConditions.length) {
        const userTypes = this.calculateUserProperties(
          this.listTypeConditions,
          this.applicationData,
          [],
          "type"
        );
        if (userTypes && userTypes.length) {
          requestBody.types = userTypes;
          this.userTypes = userTypes;
        }
      }

      const res = await axios.post(
        `/application-submit/?in_background=true`,
        requestBody
      );
      if (res && res.data) {
        if (!this.registeredUserId) {
          this.registeredUserId = res.data.id;
        }
      } else {
        this.mapSavedDependentObjects = {};
        this.mapSavedFileInfo = {};
        this.listSavedDocuments = [];
      }
    },
    handleClickEditName() {
      this.showInputDialog({
        title: "Title",
        listFields: [
          {
            type: FORM_TYPE.TEXTBOX,
            model: "name",
          },
        ],
        data: {
          name: this.profile.name,
        },
        onSubmitCallback: async (info) => {
          await axios.patch(`/api/profilesections/${this.profile.id}/`, {
            name: info.name,
          });
          this.reloadProfileBuilderList();
        },
      });
    },
    handleClickEditDescription() {
      this.showInputDialog({
        title: "Description",
        listFields: [
          {
            type: FORM_TYPE.TEXT_EDITOR,
            isRequired: false,
            model: "instructions",
          },
        ],
        data: {
          instructions: this.profile.instructions || "",
        },
        onSubmitCallback: async (info) => {
          await axios.patch(`/api/profilesections/${this.profile.id}/`, {
            instructions: info.instructions,
          });
          this.reloadProfileBuilderList();
        },
      });
    },
    async handleUploadFile(info) {
      const fileLink = this.convertToAbsolutePath(info);
      // const fileLink = 'https://enginehireio-static-and-media.s3.amazonaws.com/media/user_upload_files/2/52/no_email/NWoZK3kTsExUVw/Tayler%20_McGee_Resume.pdf';
      const res = await axios.post(
        "https://vauctehb57kjsxa7rwgyz5a2ja0lodrf.lambda-url.us-east-2.on.aws/",
        {
          cv_url: fileLink,
          agency_id: this.agencyID,
        }
      );
      if (!res || !res.data || !res.data.data || !res.data.data.profile) {
        const errorCode = this.tryGet(() => res.data.error.code);
        this.showErrorDialog({
          key: 'PARSE_CV_ERROR_DIALOG',
          params: [errorCode]
        })
        return;
      }
      await axios.post('/api/logs-management/log-event/', {
        component: 'Here API Lambda'
      })
      const profileInfo = res.data.data.profile;
      const basicInfo = profileInfo.basics;
      if (basicInfo) {
        if (basicInfo.emails && basicInfo.emails.length) {
          this.applicationData.email = basicInfo.emails[0];
        }
        if (basicInfo.phone_numbers && basicInfo.phone_numbers.length) {
          this.applicationData.phone = basicInfo.phone_numbers[0];
        }
        if (basicInfo.first_name) {
          this.applicationData.first_name = basicInfo.first_name;
        }
        if (basicInfo.last_name) {
          this.applicationData.last_name = basicInfo.last_name;
        }
        if (basicInfo.date_of_birth && basicInfo.date_of_birth.day) {
          let day = basicInfo.date_of_birth.day;
          let month = basicInfo.date_of_birth.month;
          const year = basicInfo.date_of_birth.year;
          if (day && month && year) {
            if (month < 10) {
              month = `0${month}`;
            }
            if (day < 10) {
              day = `0${day}`;
            }
            this.applicationData.birthday = `${year}-${month}-${day}`;
          }
        }
        if (basicInfo.address) {
          this.applicationData.address1 = basicInfo.address;
        }
        this.applicationData = {...this.applicationData};
      }
      const listDependentKeys = [];
      const mapApiKeyLabel = {};
      for (const itemLabel of Object.keys(this.mapDependentLabelName)) {
        const itemName = this.mapDependentLabelName[itemLabel];
        const apiKey = this.tryGet(() => MAP_DIALOG_SECTION[itemName].apiKey);
        if (apiKey && !listDependentKeys.includes(apiKey)) {
          listDependentKeys.push(apiKey);
          mapApiKeyLabel[apiKey] = itemLabel;
        }
      }
      if (listDependentKeys.includes('education')) {
        const educations = profileInfo.educations;
        if (educations && educations.length) {
          this.mapDependentObjects[mapApiKeyLabel['education']] = educations.map(item => {
            const education = {
              type: mapApiKeyLabel['education'],
              institution: item.issuing_organization,
              graduated: !item.is_current
            };
            if (item.start_year) {
              education.start_date = `${item.start_year}-01-01`
            }
            if (item.end_year) {
              education.end_date = `${item.end_year}-01-01`
            }
            if (item.description) {
              education.note = item.description;
            }
            return education;
          });
        }
      }

      if (listDependentKeys.includes('references')) {
        const references = profileInfo.references;
        if (references && references.length) {
          this.mapDependentObjects[mapApiKeyLabel['references']] = references.map(item => {
            const reference = {
              type: mapApiKeyLabel['references'],
              first_name: item.first_name,
              last_name: item.last_name,
              email: item.email,
              phone: item.phone_number
            };
            return reference;
          });
        }
      }

      if (listDependentKeys.includes('experiences')) {
        const experiences = profileInfo.professional_experiences || profileInfo.experiences;
        if (experiences && experiences.length) {
          this.mapDependentObjects[mapApiKeyLabel['experiences']] = experiences.map(item => {
            const experience = {
              type: mapApiKeyLabel['experiences'],
              company_name: item.company,
              person_worked_for_name: item.company,
              title: item.title,
              current_role: item.is_current
            };
            if (item.start_date && item.start_date.year) {
              let month = item.start_date.month || 1;
              if (month < 10) {
                month = `0${month}`;
              }
              experience.start_date = `${item.start_date.year}-${month}-01`
            }
            if (item.end_date && item.end_date.year) {
              let month = item.end_date.month || 1;
              if (month < 10) {
                month = `0${month}`;
              }
              experience.end_date = `${item.end_date.year}-${month}-01`
            }
            return experience;
          });
        }
      }
      this.mapDependentObjects = {...this.mapDependentObjects};

      console.log(res.data);
    },
  },
};
</script>
<style scoped>
.application-form-container {
  margin-top: 48px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.agency-owner {
  text-transform: unset;
}

.result-section {
  color: var(--coredarkcolor);
  font-weight: 600;
  text-align: center;
}

.instructions-section {
  /* max-width: 95%; */
}

.checkbox-condition-require {
  margin-top: 0;
  margin-bottom: 4px;
  margin-left: -1.5rem;
}

.previous-button {
  margin-right: 1em;
}

.progress-container {
  border-radius: 20px;
  border: solid 1px #1e7ac4;
  height: 20px;
}

.current-progress {
  border-radius: 20px;
  height: 100%;
  /* background-color: #1e7ac4; */
  background-color: var(--coredarkcolor);
}

.step-status-text {
  padding-bottom: 5px;
  padding-left: 7px;
  font-weight: 600;
}
.file-with-info-container {
  background-color: #fff;
}

.undo-redo-btn:not(.disabled) {
  cursor: pointer;
}

.undo-redo-btn.disabled {
  opacity: 0.5;
  cursor: context-menu;
}

.undo-redo-panel {
  position: sticky;
  top: 0;
  background: white;
  background-color: white;
  z-index: 100;
}

.undo-redo-panel > div {
  align-items: center;
}

.modify-builder-property {
  cursor: pointer;
  font-size: 0.6em;
}

.modify-builder-instruction {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: 20px;
}

.instruction-container {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/agents/builder/ApplicationForm.vue